import { FetchOptions, SerializedEntity } from "@cuba-platform/rest";
import { getCubaREST } from "@cuba-platform/react";
import { SortOrder } from "antd/lib/table/interface";
import moment, { Moment } from "moment";
import { AssignedGoal } from "./entities/base/tsadv$AssignedGoal";
import { ProcessInstanceData } from "./entities/base/bproc_ProcessInstanceData";
import { ExtTaskData } from "./entities/base/tsadv_ExtTaskData";
import { BprocFormData } from "./entities/bproc/bproc_FormData";
import { ProcessDefinitionData } from "./entities/base/bproc_ProcessDefinitionData";
import { BpmRolesDefiner } from "./entities/base/tsadv$BpmRolesDefiner";
import { NotPersisitBprocActors } from "./entities/base/tsadv_NotPersisitBprocActors";
import { CourseSection } from "./entities/base/tsadv$CourseSection";
import { AnsweredQuestion, AnsweredTest, TestModel } from "../app/components/Test/TestComponent";
import { Comment } from "../app/pages/Material/MaterialReviews";
import { SecurityState } from "../app/util/EntitySecurityState";
import { OrgStructureRequest } from "./entities/base/tsadv_OrgStructureRequest";
import {
  OrgRequestGrade,
  OrgRequestRow,
  OrgRequestSaveModel,
} from "../app/pages/orgStructureRequest/OrgStructureRequestEdit";
import { OrganizationSaveModel } from "../app/pages/orgStructureRequest/OrganizationEditor";
import { PositionSaveModel } from "../app/pages/orgStructureRequest/PositionEditor";
import { InsuredPerson } from "./entities/base/tsadv$InsuredPerson";
import { ScheduleOffsetsRequest } from "./entities/base/tsadv_ScheduleOffsetsRequest";
import { AnsweredFeedback } from "../app/pages/MyCourse/RenderModalBody/Feedback/FeedbackQuestionAnswerComponent";
import { LearningFeedbackQuestion } from "./entities/base/tsadv$LearningFeedbackQuestion";
import { DicCompany } from "./entities/base/base_DicCompany";
import { Enrollment } from "./entities/base/tsadv$Enrollment";
import { MyTeamNew, MyTeamWithEnterprise } from "./entities/base/tsadv$MyTeamNew";
import { HierarchyElementExt } from "./entities/base/base$HierarchyElementExt";
import { PersonProfile } from "../app/pages/MyTeam/MyTeamCard";
import { CourseSectionAttempt } from "./entities/base/tsadv$CourseSectionAttempt";
import { DicHrRole } from "./entities/base/tsadv$DicHrRole";
import { EnrollmentStatus, RequestType } from "./enums/enums";
import { PositionGroupExt } from "./entities/base/base$PositionGroupExt";
import { saveFile } from "../app/util/util";
import { Report } from "./entities/base/report$Report";
import { GanttChartVacationScheduleData } from "../app/components/VacationGanttChart";
import { VacationScheduleRequest } from "./entities/base/tsadv_VacationScheduleRequest";
import { Menu } from "../app/pages/UserSettings/UserSettingMainSection";
import { BpmUserSubstitution } from "./entities/base/tsadv$BpmUserSubstitution";
import { PositionHierarchy } from "./entities/base/tsadv_PositionHierarchy";
import { PersonMedal } from "./entities/base/tsadv$PersonMedal";
import { PersonMedalRequest } from "./entities/base/tsadv_PersonMedalRequest";
import { AbstractBprocRequest } from "./entities/base/AbstractBprocRequest";
import { action, toJS } from "mobx";
import { DicAbsenceType } from "./entities/base/tsadv$DicAbsenceType";
import { AssignmentSchedule } from "./entities/base/tsadv$AssignmentSchedule";
import { EntitiesResult, QuerySettings } from "../app/components/querySettings";
import { PersonGroupExt } from "./entities/base/base$PersonGroupExt";
import { OrganizationGroupExt } from "./entities/base/base$OrganizationGroupExt";
import { DismissalRequest } from "./entities/base/tsadv_DismissalRequest";
import { Punishment } from "./entities/base/tsadv$Punishment";
import { PositionGroupDetails } from "./entities/base/tsadv_PositionGroupDetails";
import { JobDescriptionRequestJson } from "./entities/base/tsadv_JobDescriptionRequestJson";
import { PositionInfo } from "../app/pages/VacancyRequest/VacancyRequestEdit";
import { AssignmentSalaryPojo } from "../app/pages/Wccf/WccfEdit";
import { AssignmentExt } from "./entities/base/base$AssignmentExt";
import { TableDataParent } from "../app/pages/LearningBudget/Approvment/BudgetTableComponent";
import { VacancyRequest } from "./entities/base/tsadv_VacancyRequest";
import { KpiEmployee } from "../app/pages/AssignedGoals/CascadeBtn";
import { CascadePojo } from "../app/pages/AssignedGoals/CascadeGoal/Cascade";
import { OrganizationGroup } from "./entities/base/base$OrganizationGroup";
import { OrganizationTree } from "./entities/base/tsadv$OrganizationTree";
import { OrganizationHrUser } from "./entities/base/tsadv$OrganizationHrUser";
import { TsadvUser } from "./entities/base/tsadv$UserExt";
import { RequisitionDataParent } from "../app/pages/Vacancies/VacancyBrowse";
import { FileDescriptor } from "./entities/base/sys$FileDescriptor";
import { PositionCourse } from "./entities/base/tsadv_PositionCourse";
import { AdaptationServiceGetAssessmentResult, DocumentsFamiliarization } from "./entities/base/tsadv_AdaptationPlan";
import { BaseUserExt } from "./entities/base/base$UserExt";

import { ApproveTd } from "../app/pages/LearningRequest/ApproveTdModal";
import { InsuredPersonKzm } from "./entities/kzm_InsuredPersonKzm";
import { RootObject } from "../app/pages/AssignedGoals/CBAGoal/CBAGoal";
import { AbsenceRvdRequestKzm } from "./entities/kzm_AbsenceRvdRequestKzm";
import { AbsenceRequest } from "./entities/base/tsadv$AbsenceRequest";
import { PersonExt } from "./entities/base/base$PersonExt";
import { GradeDetail } from "./entities/base/tsadv_GradeDetail";
import { GradeDetailAnswer } from "./entities/base/tsadv_GradeDetailAnswer";
import { PersonMedalRequest2PersonGroupLink } from "./entities/base/tsadv_PersonMedalRequest2PersonGroupLink";
import { WccfType } from "../app/pages/Wccf/WccfService";
import { PositionStructurePojo } from "./entities/PositionStructurePojo";
import { LearningBudgetRequestHeader } from "./entities/base/tsadv_LearningBudgetRequestHeader";
import { DicCostCenter } from "./entities/base/tsadv$DicCostCenter";
import { PositionGroup } from "./entities/base/base$PositionGroup";
import { BudgetOrganizationStructurePojo } from "../app/pages/LearningBudget/BudgetOrganizationStructurePojo";
import { LearningBudget } from "./entities/base/tsadv_LearningBudget";
import {
  CalculateData,
  CalculateNationalResult,
  CalculateResult,
} from "../app/pages/LearningBudget/Calculate/CalculateData";
import { Mentor } from "./entities/kzm_Mentor";
import { PersonMentorKzm } from "./entities/kzm_PersonMentor";
import { UcoSignRegistration } from "./entities/base/ucosign$Registration";
import { PortalFeedbackQuestionAnswer } from "./entities/kzm_PortalFeedbackQuestionAnswer";
import { PunishmentKzm } from "./entities/kzm_PunishmentKzm";
import { TrainingOnADayOffRequestKzm } from "./entities/kzm_TrainingOnADayOffRequestKzm";
import { EmployeeData } from "../app/pages/DictionaryEmployee/types";
import {
  GetVacanciesInnerParams,
  IVacancyInfo,
  ResponseCategory,
  ResponseCity,
  ResponseResult,
  ResponseVacancy,
} from "../app/pages/OrganizationVacancy/vacancy-type";
import {
  IBusinessTrip,
  IBusinessTripSheet,
} from "../app/pages/BusinessTripRequest/business-trip-sheet/businessTripSheet.type";
import { GetVacancyParams } from "../app/pages/OrganizationVacancy/vacancy-hooks/get-list-vacancy.hook";
import { ListOfAcknowledgement } from "./entities/base/tsadv_ListOfAcknowledgement";
import { IWorkaroundSheet } from "../app/pages/workaround-sheet/workaroundSheet.type";
import { BusinessTripRequest } from "./entities/kzm_BusinessTripRequest";
import { OrderChangeRequestType } from "../app/pages/order-change-request/order-request-list";
import { OrganizationWithPredpriatie } from "./entities/base/base$Organization";
import { IAdditionalApproverDTO } from "../app/pages/Bproc/modal/approver-management-modal";
import { IndicatorsKPI } from "../app/features/kpi/indicator-dynamic/types";
import { PersonNutrition } from "../app/entities/product-availability";
import { IOrderRegisterSheet } from "../app/pages/RegisterOrderRequest/register-order-sheet/order-register-sheet.type";
import { BprocHistoryAll } from "../app/entities/approvers-history/types/type";
import { EmployeeOverlappingServicePojo } from "../app/pages/PositionOverlappingRequest/type";
import { BprocActors } from "./entities/base/tsadv_BprocActors";
import { VacationPojo } from "../app/pages/VacationSchedule/types";
import {
  LoadPortalFeedbackQuestionsParam,
} from "../app/feature/portal-feedback-questions/api/use-load-portal-feedback-questions";
import { FeedbackQuestionWrapper } from "@entities/portal-feedback-questions/model/type";
import {
  LoadPortalFeedbackQuestionsAnswerParam
} from "../app/feature/portal-feedback-questions-answer/api/use-load-portal-feedback-questions-answer";
import {FeedbackQuestionAnswerDto} from "@entities/portal-feedback-questions-answer/model/type";

export const DEFAULT_DATE_PARSE_FORMAT = "YYYY-MM-DD hh:mm:ss";

export type Sort = {
  columnKey: string;
  order: SortOrder;
};

export type DefaultRestParams = {
  page?: number;
  pageSize?: number;
  sort?: Sort;
};

export type TelegramDto = {
  qrCode?: string;
  link?: string;
};

export type CourseTrainerInfo = {
  fullName?: string;
  finished?: number;
  courseCount?: number;
  image?: any;
  comments?: any[];
  information?: string;
  greeting?: string;
};
export type ITypeRegistration = "SIGNED" | "UNSIGNED" | "EXPIRED" | "IIN" | "BIN" | "UNSIGNED_EMPL" | ""
export type EnrollmentForMyTeamPojo = {
  fullName: string;
  organizationName: string;
  positionName: string;
  personGroupId: string;
  isEnrolled: boolean;
  scheduleName: string;
};

export type CourseSectionAttemptResponse = {
  data: EnrollmentForMyTeamPojo[];
  count: number;
};

export type PairModel<K, V> = {
  key: K;
  value: V;
};

export type ScormInputData = {
  fieldId: string;
  answer: string;
  score: number;
  maxScore: number;
  minScore: number;
};

export type RequestAbsenceDataType = {
  success: boolean;
  error_message_ru: string | undefined | null;
  error_message_en: string | undefined | null;
  error_message_kz: string | undefined | null;
};

export type CourseCatalogModel = {
  id: string;
  langValue: string;
  courses: Array<{
    id: string;
    name: string;
    enrollmentId?: string;
    enrollmentStatus?: EnrollmentStatus;
    logo: string;
    isOnline: boolean;
  }>;
};
export type rating = {
  key: number;
  value: number;
};

export type EnrollmentCatalogModel = {
  id: string;
  langValue: string;
  courses: Array<{
    id: string;
    name: string;
    enrollmentId?: string;
    enrollmentStatus?: EnrollmentStatus;
    logo?: string;
    isOnline?: boolean;
    rating: rating[];
    commentCount?: number;
    scheduleId?: string;
    scheduleName: string;
  }>;
};

export type OrgStructureFilterParams = {
  requestId: string;
} & (
  | { changeTypeFilter: "ALL" | "NEW" | "EDIT" | "CLOSE" }
  | { displayFilter: "ALL" | "CHANGES" }
  );

type ReportExtension =
  | "xls"
  | "doc"
  | "docx"
  | "xlsx"
  | "html"
  | "pdf"
  | "csv"
  | "custom";

type ReportResponse = {
  extension: ReportExtension;
  content: string;
};

export const restServices = {
  userMenuService: {
    getTimeZones: (params?: {}, fetchOpts?: FetchOptions) => {
      return getCubaREST()!.invokeService(
        "tsadv_UserSettingService",
        "getTimeZones",
        { ...params },
        fetchOpts,
      );
    },
    changePassword: (
      params: { oldPassword: string; newPassword: string },
      fetchOpts?: FetchOptions,
    ) => {
      return getCubaREST()!.invokeService(
        "tsadv_LmsService",
        "changePassword",
        { ...params },
        fetchOpts,
      );
    },
  },
  notificationsService: {
    notifications: (params?: {}, fetchOpts?: FetchOptions) => {
      return getCubaREST()!.invokeService(
        "tsadv_NotificationService",
        "notifications",
        { ...params },
        fetchOpts,
      );
    },
    tasks: (params?: {}, fetchOpts?: FetchOptions) => {
      return getCubaREST()!.invokeService(
        "tsadv_NotificationService",
        "tasks",
        { ...params },
        fetchOpts,
      );
    },
    sendNotificationNextParticipant: (param: {
      personAssessmentId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_AssessmentParticipantAssessmentsBrowseService",
          "sendActivityAndNotificationToNextParticipant",
          { ...param },
        )
        .then((v) => v);
    },
    closeAllNotificationsForCurrentUser: (): Promise<any> => {
      return getCubaREST()!.invokeService(
        "tsadv_NotificationService",
        "closeAllNotificationsForCurrentUser",
        {},
      );
    },
    closeNotificationsForCurrentUserById: (param: {
      notificationsDto: {
        notificationIds: string[];
      };
    }): Promise<any> => {
      return getCubaREST()!.invokeService(
        "tsadv_NotificationService",
        "closeNotificationsForCurrentUserById",
        { ...param },
      );
    },
  },
  orderRegisterSheetService: {
    getOrderRegisterSheetForEmployeeById: (param: {
      orderRegisterSheetId: string;
      employeeId: string;
    }): Promise<IOrderRegisterSheet> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_OrderRegisterSheetService",
          "getOrderRegisterSheetForEmployeeById",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },

    closeOrderRegisterSheetTask: (param: {
      employeeId: any;
      orderRegisterSheetId: any;
      orderRegisterSheetTaskId: any;
      taskStatus: any;
      comment: any;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_OrderRegisterSheetService",
          "closeOrderRegisterSheetTask",
          { ...param },
        )
        .then((r) => r || "");
    },

    saveOrderRegisterSheetAttachments: (param: {
      orderRegisterSheetId: string;
      fileIdList: string[];
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_OrderRegisterSheetService",
          "saveOrderRegisterSheetAttachments",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },

    getOrderRegisterSheetByOrderId: (param: {
      orderId: string;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_OrderRegisterSheetService",
        "getOrderRegisterSheetByOrderId",
        { ...param },
      );
    },
  },
  goalsProcessService: {
    clearRoutesByBusinessTripRequestId: (param: {
      businessTripRequestId: string;
    }): Promise<IBusinessTrip[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "clearRoutesByBusinessTripRequestId",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },
    saveChangeOrCancelBusinessTripRequest: (param: {
      parentRequestId: string;
      requestNumber: number;
      type: RequestType;
    }): Promise<string> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "saveChangeOrCancelBusinessTripRequest",
          { ...param },
        )
        .then((r) => r || "");
    },
    getBusinessTripRequestById: (param: {
      businessTripRequestId: string;
      isAbroad: boolean;
    }): Promise<IBusinessTrip[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "getBusinessTripRequestById",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },
    getBusinessTripSheetByRequestId: (param: {
      requestId: string;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "kms_BusinessTripService",
        "getBusinessTripSheetByRequestId",
        { ...param },
      );
    },
    getBusinessTripSheetForEmployeeById: (param: {
      employeeId: string;
      businessTripSheetId: string;
    }): Promise<IBusinessTripSheet> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "getBusinessTripSheetForEmployeeById",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },
    closeBusinessTripSheetTask: (param: {
      employeeId: any;
      businessTripSheetId: any;
      businessTripSheetTaskId: any;
      taskStatus: any;
      comment: any;
    }): Promise<IBusinessTripSheet> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "closeBusinessTripSheetTask",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },

    saveBusinessTripSheet: (param: {
      businessTripSheetId: string;
      fileIdList: string[];
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "saveBusinessTripSheet",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },
    registrationIsSignedForUser: (param: {
      registrationId: string;
      userId: string;
      isIin?: boolean;
    }): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "registrationIsSignedForUser",
          { ...param, isIin: param.isIin || false },
        )
        .then((r) => r && JSON.parse(r));
    },


    getWorkaroundSheetByEmployee: (param: { employeeId: string }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "kms_WorkaroundSheetService",
        "getWorkaroundSheetByEmployee",
        { ...param },
      );
    },
    getWorkaroundSheetForEmployeeById: (param: {
      employeeId: string;
      workaroundSheetId: string;
    }): Promise<IWorkaroundSheet> => {
      return getCubaREST()!.invokeService<string>(
        "kms_WorkaroundSheetService",
        "getWorkaroundSheetForEmployeeById",
        { ...param },
      ).then(r => r && JSON.parse(r));
    },
    closeWorkaroundSheetTask: (param: {
      employeeId: any;
      workaroundSheetId: any;
      workaroundSheetTaskId: any;
      taskStatus: any;
      comment: any;
    }): Promise<IWorkaroundSheet> => {
      return getCubaREST()!.invokeService<string>(
        "kms_WorkaroundSheetService",
        "closeWorkaroundSheetTask",
        { ...param },
      ).then(r => r && JSON.parse(r));
    },

    saveWorkaroundSheet: (param: {
      transferWithinGroup: boolean;
      workaroundSheetId: string;
      fileIdList: string[];
    }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "kms_WorkaroundSheetService",
        "saveWorkaroundSheet",
        { ...param },
      ).then(r => r && JSON.parse(r));
    },
    getBusinessTripRequestsForTransportRequest: (param: {
      personGroupId: string;
    }): Promise<BusinessTripRequest[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kms_BusinessTripService",
          "getBusinessTripRequestsForTransportRequest",
          { ...param },
        )
        .then((r) => r && JSON.parse(r));
    },
  },
  learningService: {
    getCourseRatings(
      courseId: string,
      limit: number,
      nextOffset: number,
      rating: number | null,
    ): Promise<Array<Comment>> {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getCourseRatings", {
          courseId,
          limit,
          nextOffset,
          rating,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    getDocumentList(userId: string): Promise<ListOfAcknowledgement[]> {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getDocumentList", {
          userId,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    getBalanceForLearningContract: (params: {
      totalCost: BigInt;
      termOfWork: Date;
      contractDate: Date;
    }): Promise<number> => {
      return getCubaREST()!
        .invokeService<number>(
          "tsadv_LearningService",
          "getBalanceForLearningContract",
          { ...params },
        )
        .then((value) => (value ? Math.round(value) : value));
    },
    learningHistory: (params: { personGroupId: string }): Promise<any[]> => {
      return getCubaREST()!
        .fetch("GET", "learning-history", { ...params })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    createScheduleEnrollment: (params: {
      personGroupId: string;
      scheduleId: string;
      status: number;
      user: string;
    }): Promise<any[]> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "createScheduleEnrollment", {
          ...params,
        })
        .then((response: any) => {
          return JSON.parse(response);
        });
    },
    getOrganizationHierarchy: (params: {
      organizationId: any;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getOrganizationHierarchy", {
          ...params,
        })
        .then((r: any) => {
          return r;
        });
    },
    getPositionHierarchy: (params: { positionId: string }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getPositionHierarchy", {
          ...params,
        })
        .then((r: any) => {
          return r;
        });
    },
    createAssessment: (params: {
      personAssessmentId: string;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "tsadv_LearningService",
        "createAssessment",
        { ...params },
      );
    },
    createAssessmentParticipant: (params: {
      personAssessmentId: string;
      personGroupId: string;
      code: string;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "tsadv_LearningService",
        "createAssessmentParticipant",
        { ...params },
      );
    },
    getConcourseRequest: (param: { personGroupId: string }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getConcourseRequest", {
          ...param,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    getNewNineBox: (params: {
      organizationGroupId: string;
      lang: string;
      appraisalProcessId: string;
      performancePlanId: string;
      idp: boolean;
    }): any => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getNewNineBox", {
          ...params,
        })
        .then((res: any) => {
          const value = JSON.parse(res);
          return JSON.parse(value && value[0] && value[0].value);
        });
    },
    getNineBox: (params: {
      organizationGroupId: string;
      lang: string;
      appraisalProcessId: string;
      ldp: boolean;
    }): any => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getNineBox", {
          ...params,
        })
        .then((res: any) => {
          const value = JSON.parse(res);
          return JSON.parse(value && value[0] && value[0].value);
        });
    },
    getPersonCourseSchedule: async (params: {
      personGroupId: string;
    }): Promise<any[]> => {
      const res = await getCubaREST()!.invokeService<string>(
        "tsadv_LearningService",
        "getPersonCourseSchedule",
        {
          ...params,
        },
      );

      if (!res || res.length < 0) {
        return [];
      }
      const json = JSON.parse(res);

      if (!Array.isArray(json)) {
        return [];
      }

      if (json[0]) {
        return JSON.parse(json[0]?.value);
      }

      return [];
    },
    getMyAssessments: (params: {
      personGroupId: string;
      lang: string;
    }): Promise<any[]> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getMyAssessments", {
          ...params,
        })
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    createCandidateForReferral: (params: {
      firstName: string;
      lastName: string;
      requisitionId: string;
      mobilePhone: string;
      email: string;
      birthDate: string;
    }): Promise<PersonGroupExt> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "createCandidateForReferral", {
          ...params,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    getPersonAssessments: (params: {
      personGroupId: string;
      lang: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getPersonAssessments", {
          ...params,
        })
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    getPersonAssessmentForm: (params: {
      personGroupId: string;
      lang: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getPersonAssessmentForm", {
          ...params,
        })
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    updateAssessment: (params: {
      assessmentId: string | null;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_AssessmentParticipantAssessmentsBrowseService",
          "updateAssessment",
          { ...params },
        )
        .then((r) => r);
    },
    getSuccessionKeyPosition: (params: {
      lang: string;
      company: string;
      position: string;
      organization: string;
      holder: string;
      manager: string;
      reservist: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getSuccessionKeyPosition", {
          ...params,
        })
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    getSuccessionKeyPositionInfo: (params: {
      lang: string;
      positionGroupId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_LearningService",
          "getSuccessionKeyPositionInfo",
          { ...params },
        )
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    createJobRequestForRecommendation: (params: {
      candidatePersonGroup: string;
      requisition: string;
      requestDate: string;
    }) => {
      return getCubaREST()!.invokeService(
        "tsadv_LearningService",
        "createJobRequestForRecommendation",
        { ...params },
      );
    },
    getStudentRating: (params: {
      lang: string;
      company: string;
      searchText: string;
      type: string | null;
      year: number;
      month: number | null;
      limit: number;
      nextOffset: number;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_LearningService", "getStudentRating", {
          ...params,
        })
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
  },
  courseService: {
    courseInfo: (params: {
      courseId: string;
      personGroupId: string;
    }): Promise<CourseInfo> => {
      return getCubaREST()!
        .invokeService("tsadv_CourseService", "courseInfo", {
          ...params,
        })
        .then((response: string) => {
          const courseInfo: CourseInfo = JSON.parse(response) as CourseInfo;
          courseInfo.startDate = moment(
            courseInfo.startDate,
            DEFAULT_DATE_PARSE_FORMAT,
          );
          courseInfo.endDate = moment(
            courseInfo.endDate,
            DEFAULT_DATE_PARSE_FORMAT,
          );

          return courseInfo;
        });
    },
    courseTrainerInfo: (params: {
      trainerId: string;
    }): Promise<CourseTrainerInfo> => {
      return getCubaREST()!
        .invokeService("tsadv_CourseService", "courseTrainerInfo", {
          ...params,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    courseEnrollmentInfo: (params: {
      enrollmentId: string;
    }): Promise<Enrollment> => {
      return getCubaREST()!
        .invokeService("tsadv_CourseService", "courseEnrollmentInfo", {
          ...params,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    courseSectionWithEnrollmentAttempts: (params: {
      courseSectionId: string;
      enrollmentId: string;
    }): Promise<CourseSection> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_CourseService",
          "courseSectionWithEnrollmentAttempts",
          { ...params },
        )
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    createScormAttempt: (params: {
      courseSectionId: string;
      enrollmentId: string;
      inputData: ScormInputData[];
      success: boolean;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "tsadv_CourseService",
        "createScormAttempt",
        { ...params },
      );
    },
    createTestScormAttempt: (params: {
      courseSectionId: string;
      enrollmentId: string;
      score: number;
      maxScore: number;
      minScore: number;
    }): Promise<CourseSectionAttempt> => {
      return getCubaREST()!
        .invokeService("tsadv_CourseService", "createTestScormAttempt", {
          ...params,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    validateEnroll: (params: {
      courseId: string;
      personGroupId: string;
      locale: string;
    }): Promise<PairModel<boolean, string[]>> => {
      return getCubaREST()!
        .invokeService("tsadv_CourseService", "validateEnroll", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    validateMaxPeopleEnroll: (params: {
      courseId: string;
      courseScheduleId: string | null;
      locale: string;
    }): Promise<{ key: boolean; value?: string }> => {
      return getCubaREST()!
        .invokeService("tsadv_CourseService", "validateMaxPeopleEnroll", {
          ...params,
        })
        .then((res: string) => JSON.parse(res));
    },
    getCourseSubCategoriesWithCourseSearchAndPagination: (params: {
      personGroupId: string;
      searchString: string;
      offset: number;
      limit: number | null;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_CourseService",
          "getCourseSubCategoriesWithCourseSearchAndPagination",
          { ...params },
        )
        .then((response: any) => JSON.parse(response));
    },
    getSubCategoryCoursesWithSearchAndPagination: (params: {
      subCategoryId: string;
      personGroupId: string;
      companyCode: string;
      lang: string;
      searchString: string | null;
      offset: number;
      limit: number;
    }): Promise<any[]> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_CourseService",
          "getSubCategoryCoursesWithSearchAndPagination",
          { ...params },
        )
        .then((response: any) => response ? JSON.parse(response) : []);
    },
  },
  kpiService: {
    kpiAssignedGoals: (params: {
      appId: string;
    }): Promise<PairModel<string, SerializedEntity<AssignedGoal>[]>[]> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "kpiAssignedGoals", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    getAverageResultPlansByPerson: (params: {
      personGroupId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "getAverageResultPlansByPerson", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    copyGoalsFromPreviousAssignedPerformancePlan: (params: {
      assignedPerformancePlanId: string;
    }): Promise<ResponseResult> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "copyGoalsFromPreviousAssignedPerformancePlan", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    getIndicatorsDynamic: (params: {
      personGroupId: string;
      year: string;
    }): Promise<IndicatorsKPI> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "getIndicatorsDynamic", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    getKpiSubordinateEmployees: (params: {
      goalId: string;
    }): Promise<SerializedEntity<KpiEmployee>[]> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "getKpiSubordinateEmployees", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    cascadeAssignedGoal: (params: {
      goalId: string;
      cascadePojos: CascadePojo[];
    }): Promise<ResponseResult> => {
      return getCubaREST()!.invokeService(
        "tsadv_KpiService",
        "cascadeAssignedGoal",
        { ...params },
      ).then((response: string) => JSON.parse(response));
    },
    getPersonAssessmentForm: (param: {
      personAssessmentId: string;
      lang: string;
      personGroupId: string;
    }): Promise<RootObject> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "getPersonAssessmentForm", {
          ...param,
        })
        .then((response: string) => JSON.parse(response));
    },
    updateAssessment: (param: {
      assessmentId: string;
      personGroupId: string;
    }): Promise<RootObject> => {
      return getCubaREST()!
        .invokeService("tsadv_KpiService", "updateAssessment", { ...param })
        .then((response: string) => JSON.parse(response));
    },
    getAssignmentForDate: (params: {
      personGroupId: string;
      date: any | null;
    }): Promise<SerializedEntity<AssignmentExt>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_KpiService", "getAssignmentForDate", {
          ...params,
        })
        .then((r) => r && JSON.parse(r));
    },
  },
  assignedGoalService: {
    getAssignedGoalFullHierarchy: (params: {
      assignedGoalId: string;
    }): Promise<Array<AssignedGoal>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignedGoalService",
          "getAssignedGoalFullHierarchy",
          { ...params },
        )
        .then((value) => JSON.parse(value));
    },
  },
  enrollmentService: {
    searchEnrollments: (params: {
      personGroupId: string;
      courseName?: string | null;
    }): Promise<SerializedEntity<EnrollmentCatalogModel>[]> => {
      params = { ...params, courseName: params.courseName || null };
      return getCubaREST()!
        .invokeService("tsadv_EnrollmentService", "searchEnrollment", {
          ...params,
        })
        .then((response: string) => JSON.parse(response));
    },
    getEnrollmentForMyTeam: (
      positionGroupId: string,
      courseId: string,
      fio: string,
      limit: number,
      offset: number,
    ): Promise<CourseSectionAttemptResponse> => {
      return getCubaREST()!
        .invokeService("tsadv_EnrollmentService", "getEnrollmentForMyTeam", {
          positionGroupId,
          courseId,
          fio,
          limit,
          offset,
        })
        .then((response: string) => JSON.parse(response));
    },
  },
  telegramService: {
    registerUserByTelegramCode(tempCode: string): Promise<void> {
      return getCubaREST()!
        .invokeService(
          "base_TelegramRegisterService",
          "registerUserByTelegramCode",
          { tempCode },
        )
        .then((response: string) => {
          if (response !== "true") {
            throw new Error("Wrong code");
          }
        });
    },
    getTelegramLinkForCurrentUser(): Promise<TelegramDto> {
      return getCubaREST()!
        .invokeService(
          "base_TelegramRegisterService",
          "getTelegramLinkForCurrentUser",
          {},
        )
        .then((response: string) => JSON.parse(response));
    },
  },
  lmsService: {
    loadCourseSectionData: (
      params: { enrollmentId: string; courseSectionId: string },
      fetchOpts?: FetchOptions,
    ): Promise<SerializedEntity<CourseSection>> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_LmsService",
          "loadCourseSectionData",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    startAndLoadTest: (
      params: { courseSectionObjectId: string; enrollmentId: string },
      fetchOpts?: FetchOptions,
    ): Promise<TestModel> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_LmsService",
          "startAndLoadTest",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    finishTest: (
      params: { answeredTest: AnsweredTest },
      fetchOpts?: FetchOptions,
    ): Promise<{
      score: number;
      maxScore: number;
      success: boolean;
    }> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_LmsService",
          "finishTest",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    finishFeedback: (
      params: {
        answeredFeedback: AnsweredFeedback;
        personGroupId: string;
      },
      fetchOpts?: FetchOptions,
    ) => {
      return getCubaREST()!.invokeService(
        "tsadv_LmsService",
        "finishFeedback",
        { ...params },
        fetchOpts,
      );
    },
    loadFeedbackData: (
      params: { feedbackTemplateId: string },
      fetchOpts?: FetchOptions,
    ): Promise<LearningFeedbackQuestion[]> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_LmsService",
          "loadFeedbackData",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
  },
  portalHelperService: {
    newEntity: <T>(param?: { entityName: string }): Promise<T> => {
      return getCubaREST()!
        .invokeService("tsadv_PortalHelperService", "newEntity", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
    companiesForLoadDictionary: (param: {
      personGroupId: string;
    }): Promise<string[]> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_PortalHelperService",
          "getCompaniesForLoadDictionary",
          { ...param },
        )
        .then((value: string) => JSON.parse(value));
    },
    initPortalMenu: (param: { menuList: Menu[] }): Promise<any> => {
      return getCubaREST()!.invokeService(
        "tsadv_PortalHelperService",
        "initPortalMenu",
        { ...param },
      );
    },
    getConfig: (
      param: { classFQN: string; methodName: string },
      fetchOpts?: FetchOptions,
    ): Promise<string> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_PortalHelperService",
          "getConfig",
          { ...param },
          fetchOpts,
        )
        .then((response: string) => response);
    },
  },
  registerOrderService: {
    tasks: (param: {
      processInstanceData: ProcessInstanceData;
    }): Promise<Array<SerializedEntity<ExtTaskData>>> => {
      return getCubaREST()!
        .invokeService("kzm_RegisterOrderService", "getProcessTasks", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
  },
  bprocService: {
    tasks: (param: {
      processInstanceData: ProcessInstanceData;
    }): Promise<Array<SerializedEntity<ExtTaskData>>> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "getProcessTasks", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
    getNextApprovers: (param: {
      request: any;
      currentTaskCode: string;
    }): Promise<BprocActors[]> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "getNextApprovers", {
          ...param,
        })
        .then((value: string) => {
          return value ? JSON.parse(value) : [];
        });
    },
    saveNextApprovers: (param: {
      request: any;
      currentTaskCode: string;
      //Массив UserExt
      selectedApprovers: any[];
    }): Promise<ExtTaskData> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "saveNextApprovers", {
          ...param,
        })
        .then((value: string) => {
          return JSON.parse(value);
        });
    },
    getActiveTask: (param: {

      processInstanceData: ProcessInstanceData;
    }): Promise<ExtTaskData> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "getActiveTask", {
          ...param,
        })
        .then((value: string) => {
          return JSON.parse(value);
        });
    },
    isActiveTask: (param: { taskData: ExtTaskData }): Promise<boolean> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "isActiveTask", {
          ...param,
        })
        .then((value: string) => {
          return JSON.parse(value);
        });
    },
    processInstanceData: (param: {
      processInstanceBusinessKey: string;
      processDefinitionKey: string;
    }): Promise<ProcessInstanceData> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "getProcessInstanceData", {
          ...param,
        })
        .then((value: string) => {
          if (value) return JSON.parse(value);
          return value;
        });
    },
    getProcessDefinitionData: (param: {
      processDefinitionKey: string;
    }): Promise<ProcessDefinitionData> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "getProcessDefinitionData", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
    getStartFormData: (param: {
      processDefinitionKey: string;
    }): Promise<BprocFormData> => {
      return getCubaREST()!
        .invokeService("tsadv_BprocService", "getStartFormData", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
  },
  bprocFormService: {
    getStartFormData: (param: {
      processDefinitionId: string;
    }): Promise<BprocFormData> => {
      return getCubaREST()!
        .invokeService("bproc_BprocFormService", "getStartFormData", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
    getTaskFormData: (param: { taskId: string }): Promise<BprocFormData> => {
      return getCubaREST()!
        .invokeService("bproc_BprocFormService", "getTaskFormData", {
          ...param,
        })
        .then((value: string) => value ? JSON.parse(value) : null);
    },
  },
  startBprocService: {
    getBpmRolesDefiner: (param: {
      request: AbstractBprocRequest;
      employeePersonGroupId: string;
      isAssistant: boolean;
    }): Promise<BpmRolesDefiner> => {
      return getCubaREST()!
        .invokeService("tsadv_StartBprocService", "getBpmRolesDefiner", {
          ...param,
        })
        .then((value: string) => JSON.parse(value));
    },
    getNotPersisitBprocActors: (param: {
      employeePersonGroupId: string;
      bpmRolesDefiner: BpmRolesDefiner;
      isAssistant: boolean;
      request: AbstractBprocRequest;
    }): Promise<Array<SerializedEntity<NotPersisitBprocActors>>> => {
      return getCubaREST()!
        .invokeService("tsadv_StartBprocService", "getNotPersisitBprocActors", {
          ...param,
          request: toJS(param.request),
        })
        .then((value: string) => {
          return JSON.parse(value);
        });
    },
    saveBprocActors: (param: {
      entityId: string;
      notPersisitBprocActors: Array<NotPersisitBprocActors>;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "tsadv_StartBprocService",
        "saveBprocActors",
        { ...param },
      );
    },
  },
  bprocRuntimeService: {
    startProcessInstanceByKey: (param: {
      processDefinitionKey: string;
      businessKey: string;
      variables: any;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "bproc_BprocRuntimeService",
        "startProcessInstanceByKey",
        { ...param },
      );
    },
  },
  bprocTaskService: {
    completeWithOutcome: (param: {
      taskData: ExtTaskData;
      outcomeId: string;
      processVariables: any;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "bproc_BprocTaskService",
        "completeWithOutcome",
        { ...param },
      );
    },
  },
  additionalApproversService: {
    filterBySeveral: (param: {
      filter: string;
    }): Promise<IAdditionalApproverDTO[]> => {
      return getCubaREST()!.invokeService(
        "tsadv_AdditionalApproversService",
        "filterBySeveral",
        { ...param },
      ).then((r: string) => JSON.parse(r));
    },

    deleteAdditionalApprovers: (param: {
      approverId: string;
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "tsadv_AdditionalApproversService",
        "deleteAdditionalApprovers",
        { ...param },
      );
    },

    createAdditionalApprovers: (param: {
      procInstanceId: string;
      personGroupIds: string[];
    }): Promise<void> => {
      return getCubaREST()!.invokeService(
        "tsadv_AdditionalApproversService",
        "createAdditionalApprovers",
        { ...param },
      );
    },

    getAdditionalApprovers: (param: {
      procInstanceId: string;
    }): Promise<IAdditionalApproverDTO[]> => {
      return getCubaREST()!.invokeService(
        "tsadv_AdditionalApproversService",
        "getAdditionalApprovers",
        { ...param },
      ).then((r: string) => JSON.parse(r));
    },
  },
  fileDownload: {
    download: (fileId: string) => {
      return getCubaREST()!
        .getFile(fileId)
        .then((value) => value);
    },
  },
  positionOverlappingRequestService: {
    checkPercentSum: (param: {
      personGroupId: string;
      percentageSubstitution: number;
      positionOverlappingRequestId: string;
    }): Promise<ResponseResult> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_PositionOverlappingRequestService",
          "checkPercentSum",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getEmployeesByFullName: (param: {
      fullName: string;
    }): Promise<EmployeeOverlappingServicePojo[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_PositionOverlappingRequestService",
          "getEmployeesByFullName",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getPercentSum: (param: {
      positionOverlappingRequestId: string;
    }): Promise<any[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_PositionOverlappingRequestService",
          "getPercentSum",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  portalAccessEntityAttributesService: {
    entityAttributesSecurityState: (param: {
      entityName: string;
      entityId: string;
    }): Promise<SecurityState> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PortalAccessEntityAttributesService",
          "entityAttributesSecurityState",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  bprocRequestService: {
    getBprocHistory: (param: {
      entityId: string;
      entityName: string;
    }): Promise<BprocHistoryAll> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_BprocRequestService",
          "getBprocHistory",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  absenceService: {
    getLaborLeave: (view = "_local"): Promise<DicAbsenceType> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_AbsenceService", "getLaborLeave", {
          view: view,
        })
        .then((value) => JSON.parse(value));
    },
    vacationDurationType: (param: {
      personGroupId: string;
      absenceTypeId: string;
      dateFrom: Date | null;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_AbsenceService",
        "getVacationDurationType",
        { ...param },
      );
    },
    countDays: (param: {
      dateFrom: string;
      dateTo: string;
      absenceTypeId: string;
      personGroupId: string;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_AbsenceService",
        "countDays",
        { ...param },
      );
    },
    countAbsenceHours: (param: {
      dateFrom: Date;
      dateTo: Date;
      absenceTypeId: string;
      personGroupId: string;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<number>(
        "tsadv_AbsenceService",
        "countAbsenceHours",
        { ...param },
      );
    },
    getReceivedVacationDaysOfYear: (param: {
      date: Date;
      absenceTypeId: string;
      personGroupId: string;
    }): Promise<number> => {
      return getCubaREST()!.invokeService<number>(
        "tsadv_AbsenceService",
        "getReceivedVacationDaysOfYear",
        { ...param },
      );
    },
    getRemainingDaysWeekendWork: (personGroupId: string): Promise<number> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AbsenceService",
          "getRemainingDaysWeekendWork",
          { personGroupId: personGroupId },
        )
        .then((value) => parseInt(value));
    },
    countDaysWithoutHolidays: (param: {
      dateFrom: string;
      dateTo: string;
      personGroupId: string;
    }): Promise<number> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AbsenceService",
          "countDaysWithoutHolidays",
          { ...param },
        )
        .then((value) => parseInt(value));
    },
    scheduleOffsetDaysBeforeAbsence: (): Promise<number | undefined> => {
      return getCubaREST()!
        .invokeService<number>(
          "tsadv_AbsenceService",
          "scheduleOffsetDaysBeforeAbsence",
          {},
        )
        .then((response) => {
          if (!response) {
            return undefined;
          }
          return response;
        });
    },
    checkAbsenceRequest: (params: {
      personGroupId: string;
      absenceTypeId: string;
      startDate: string | Date;
      endDate: string | Date;
      duration: number;
    }): Promise<RequestAbsenceDataType> => {
      return getCubaREST()!
        .invokeService("tsadv_AbsenceService", "checkAbsenceRequest", {
          ...params,
        })
        .then((response: string) => JSON.parse(response))
        .then((data: object) => JSON.parse(data[0].value));
    },
    validate: (param: { absenceRequest: AbsenceRequest }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_AbsenceRequestValidationService",
        "validate",
        { ...param },
      );
    },
    isExistAbsenceByPersonGroupInFromTo: (param:
                                          {
                                            personGroupId: string;
                                            dateFrom: string;
                                            dateTo: string;
                                            absenceTypeId: string;
                                          }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_AbsenceRequestValidationService",
        "isExistAbsenceByPersonGroupInFromTo",
        { ...param },
      ).then((response: string) => JSON.parse(response));
    },
  },
  absenceRvdService: {
    countTotalHours: (param: {
      dateFrom: any;
      dateTo: any;
      absenceTypeId: string;
      personGroupId: string;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<number>(
        "tsadv_AbsenceRvdService",
        "countTotalHours",
        { ...param },
      );
    },
    validate: (param: {
      absenceRvdRequestKzm: AbsenceRvdRequestKzm;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_AbsenceRvdRequestValidationService",
        "validate",
        { ...param },
      );
    },
  },
  absenceBalanceService: {
    getAbsenceBalance: (param: {
      absenceTypeId?: string;
      absenceDate: any;
      personGroupId: string;
    }): Promise<number> => {
      return getCubaREST()!
        .invokeService<number>(
          "tsadv_AbsenceBalanceService",
          "getAbsenceBalance",
          { ...param },
        )
        .then((value) => (value ? Math.round(value * 100) / 100 : value));
    },
    getAdditionalLeaveDays: (param: {
      absenceDate: any;
      personGroupId: string;
    }): Promise<number> => {
      return getCubaREST()!
        .invokeService<number>(
          "tsadv_AbsenceBalanceService",
          "getAdditionalLeaveDays",
          { ...param },
        )
        .then((value) => (value ? Math.round(value * 100) / 100 : value));
    },
  },
  // bdeadd48-26c4-c4c1-05eb-691d3e9cf0b6
  getNewAbbService: {
    getSignFile: (
      id: string,
      type:
        | "ABSENCE"
        | "DISMISSAL"
        | "OVERLAPPING"
        | "OVERLAPPING_ORDER"
        | "BUSINESS_TRIP"
        | "BUSINESS_TRIP_SHEET"
        | "PERSONAL_DATA",
    ): Promise<any> => {
      return getCubaREST()!
        .invokeService("kzm_AbsenceRequestService", "getAbsenceRequestData", {
          absenceRequestId: id,
          absenceType: type,
        })
        .then((response: string) => JSON.parse(response));
    },
    postCreateSignFile: (
      id: string,
      type: "ABSENCE" | "DISMISSAL" | "OVERLAPPING",
    ): Promise<any> => {
      return getCubaREST()!
        .invokeService("kzm_AbsenceRequestService", "createDocumentToSign", {
          absenceRequestId: id,
          absenceType: type,
        })
        .then((response: string) => response && JSON.parse(response));
    },
  },
  orderRegisterService: {
    findOrdersByPersonGroupId: (personGroupId: string, statusCode: "DRAFT" | "ON_APPROVAL" | "ON_SIGNING" | "REJECTED" | "APPROVED" | "SIGNED" | "CANCELED"): Promise<PersonProfile> => {
      return getCubaREST()!
        .invokeService<string>("kzm_OrderRegisterService", "findOrdersByPersonGroupId", {
          personGroupId,
          statusCode,
        })
        .then((r) => JSON.parse(r));
    },
    getListOrderChangeRequest: (personGroupId: string): Promise<OrderChangeRequestType> => {
      return getCubaREST()!
        .invokeService<string>("kzm_OrderRegisterService", "getListOrderChangeRequest", {
          personGroupId,
        })
        .then((r) => JSON.parse(r));
    },
    toRevisionOrderFromRegistration: (params: { registrationId: string; comment: string }): Promise<ResponseResult> => {
      return getCubaREST()!
        .invokeService<string>("kzm_OrderRegisterService", "toRevisionOrderFromRegistration", {
          ...params,
        })
        .then((r) => JSON.parse(r));
    },
    getOrderRegisterAdditionalInfo: (orderRegisterId: string): Promise<{ requestLinkFront: string }> => {
      return getCubaREST()!
        .invokeService<string>("kzm_OrderRegisterService", "getOrderRegisterAdditionalInfo", {
          orderRegisterId,
        })
        .then((r) => JSON.parse(r));
    },
  },
  personNutritionService: {
    getPersonNutrition: (
      params: { personId: string },
      fetchOpts?: FetchOptions,
    ): Promise<PersonNutrition[]> => {
      return getCubaREST()!
        .invokeService(
          "kzm_PersonNutritionService",
          "getPersonNutrition",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },

    createOrUpdate: (
      params: { personId: string },
      fetchOpts?: FetchOptions,
    ): Promise<any> => {
      return getCubaREST()!
        .invokeService(
          "kzm_PersonNutritionService",
          "createOrUpdate",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
  },
  documentService: {
    getInsuredPerson: (
      params: { type: string; contractId: string | undefined },
      fetchOpts?: FetchOptions,
    ): Promise<InsuredPerson> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "getInsuredPerson",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    getInsuredPersonKzm: (
      params: { type: string; contractId: string | undefined },
      fetchOpts?: FetchOptions,
    ): Promise<InsuredPersonKzm> => {
      return getCubaREST()!
        .invokeService(
          "kzm_DocumentService",
          "getInsuredPersonKzm",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    getInsuredPersonMembers: (
      params: { insuredPersonId: any },
      fetchOpts?: FetchOptions,
    ): Promise<Array<InsuredPerson>> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "getInsuredPersonMembers",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    getInsuredPersonKzmMembers: (
      params: { insuredPersonId: any },
      fetchOpts?: FetchOptions,
    ): Promise<Array<InsuredPersonKzm>> => {
      return getCubaREST()!
        .invokeService(
          "kzm_DocumentService",
          "getInsuredPersonKzmMembers",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    getInsuredPersonMembersWithNewContract: (
      params: { insuredPersonId: string; contractId: string },
      fetchOpts?: FetchOptions,
    ): Promise<Array<InsuredPerson>> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "getInsuredPersonMembersWithNewContract",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    changeStatusToDraftInsuranceContractList: (
      params: { insurancePersonIdList: string[] },
      fetchOpts?: FetchOptions,
    ): Promise<Array<InsuredPerson>> => {
      return getCubaREST()!
        .invokeService(
          "kzm_InsuredPersonKzmService",
          "changeStatusToDraftInsuranceContractList",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => response && JSON.parse(response));
    },
    getInsuredPersonKzmMembersWithNewContract: (
      params: { insuredPersonId: string; contractId: string },
      fetchOpts?: FetchOptions,
    ): Promise<Array<InsuredPersonKzm>> => {
      return getCubaREST()!
        .invokeService(
          "kzm_DocumentService",
          "getInsuredPersonKzmMembersWithNewContract",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    checkPersonInsure: (
      params: { personGroupId: any; contractId: any },
      fetchOpts?: FetchOptions,
    ): Promise<boolean> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "checkPersonInsure",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    calcAmount: (
      params: {
        personGroupId: string;
        contractId: string;
        memberId: any;
        memberBirthDate: string | Date;
        replationTypeId: string;
      },
      fetchOpts?: FetchOptions,
    ): Promise<number> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "calculateAmount",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    getMyInsurancesKzm: (
      fetchOpts?: FetchOptions,
    ): Promise<Array<InsuredPersonKzm>> => {
      return getCubaREST()!
        .invokeService("kzm_DocumentService", "getMyInsurances", fetchOpts)
        .then((response: string) => JSON.parse(response));
    },
    getContractListByPerson: (param: {
      personGroupId?: string;
    }): Promise<any> => {
      return getCubaREST()!.invokeService(
        "tsadv_DocumentService",
        "getContractListByPerson",
        { ...param },
      );
    },

    getOffsetRequestsNew: (
      params: {},
      fetchOpts?: FetchOptions,
    ): Promise<ScheduleOffsetsRequest> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "getOffsetRequestsNew",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    calcTotalAmount: (
      params: { insuredPersonId: any },
      fetchOpts?: FetchOptions,
    ): Promise<number> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_DocumentService",
          "calcTotalAmount",
          { ...params },
          fetchOpts,
        )
        .then((response: string) => JSON.parse(response));
    },
    commitFromPortal: (
      insuredPerson: InsuredPerson,
    ): Promise<InsuredPerson> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_DocumentService", "commitFromPortal", {
          insuredPerson: insuredPerson,
        })
        .then((response: string) => JSON.parse(response));
    },
  },

  employeeService: {
    personProfile: (personGroupId: string): Promise<PersonProfile> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "personProfile", {
          personGroupId: personGroupId,
        })
        .then((r) => JSON.parse(r));
    },
    findPerson: (search: string): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "findPerson", {
          search: search,
        })
        .then((r) => {
          if (!r) return [];
          const parse = JSON.parse(r)[0]?.value;
          if (!parse) return [];
          return JSON.parse(parse);
        });
    },

    getEmployeeData: (personGroupId: string): Promise<EmployeeData> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "getEmployeeData", {
          personGroupId,
        })
        .then((r) => JSON.parse(r));
    },
    checkAndCreateEmailPersonContact: (params: {
      personGroupId: string;
      email: string;
    }): Promise<void> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "checkAndCreateEmailPersonContact",
          {
            ...params,
          },
        )
        .then(() => {
        });
    },

    getPersonByPersonGroup(
      personGroupId: string,
      view: string,
    ): Promise<PersonExt> {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getPersonByPersonGroup",
          {
            personGroupId,
            view,
          },
        )
        .then((r) => JSON.parse(r));
    },
    personGroupInfo: (userId: string): Promise<PersonProfile> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "personGroupInfo", {
          userId: userId,
        })
        .then((r) => JSON.parse(r));
    },
    getCompanyByPersonGroupId: (param: {
      personGroupId: string;
    }): Promise<DicCompany> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getCompanyByPersonGroupId",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    hasHrRole: (param: { dicHrCode: string }): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "hasHrRole", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
    getManagersByPersonGroup: (personGroupId: string): Promise<TsadvUser[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getManagersByPersonGroup",
          { personGroupId: personGroupId },
        )
        .then((r) => JSON.parse(r));
    },
    getEmployees: (param: {
      date: string;
      view: string;
    }): Promise<Array<PersonGroupExt>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "getEmployees", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
    getBirthdayPeopleTodayList: (param: {
      company: string;
    }): Promise<PersonGroupExt[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getBirthdayPeopleTodayList",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getHrUsers: (param: {
      organizationGroupId: string;
      roleCodes: string | null;
    }): Promise<OrganizationHrUser[]> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_EmployeeService", "getHrUsers", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
    getEmployeeWithOrganizationAndSearch: (param: {
      organization: string | null;
      lang: string;
      search: string | null;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getEmployeeWithOrganizationAndSearch",
          { ...param },
        )
        .then((response: any) => {
          if (response) {
            const value = JSON.parse(response);
            return JSON.parse(value[0].value);
          }
        });
    },
    getPersonExperienceJson: (param: {
      pPersonGroupId: string;
      pLang: string;
      pDate: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getPersonExperienceJson",
          { ...param },
        )
        .then((r: any) => {
          return r && JSON.parse(r);
        });
    },
    searchPersonExtByFullName: (param: {
      expression: string;
      limit: string;
      offset: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "searchPersonExtByFullName",
          { ...param },
        )
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    postFetch: async (
      data: any,
      serviceName: string,
      signal?: AbortSignal,
    ): Promise<any> => {
      if (!signal) {
        const controller = new AbortController();
        signal = controller.signal;
      }
      try {
        const response = await fetch(
          getCubaREST()!.apiUrl + `v2/services/` + `${serviceName}`,
          {
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              Authorization: "Bearer " + getCubaREST()!.restApiToken,
            },
            method: "POST",
            body: JSON.stringify(data),
            signal,
          },
        );

        const result = await response.json();
        console.log(result);
        console.log("end");
        return result;
      } catch (error) {
        console.error("Произошла ошибка:", error);
        throw error;
      }
    },
    getfetch: (param: {
      lang: string;
      expression: string;
      limit: string;
      offset: string;
      servicePath: string;
    }): Promise<any> => {
      const { lang, expression, limit, offset, servicePath } = param;
      const queryParams = new URLSearchParams({
        expression,
        lang,
        offset,
        limit,
      }).toString();
      return fetch(
        getCubaREST()!.apiUrl +
        `v2/services/` +
        `${servicePath}?${queryParams}`,
        {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + getCubaREST()!.restApiToken,
          },
          method: "GET",
        },
      ).then((value) => {
        return value.json();
      });
    },

    getfetchUser: (param: {
      lang: string;
      personGroupId: string;
      membersCreateTs: string;
      servicePath: string;
    }): Promise<any> => {
      const { lang, personGroupId, membersCreateTs, servicePath } = param;
      const queryParams = new URLSearchParams({
        personGroupId,
        lang,
        membersCreateTs,
      }).toString();
      return fetch(
        getCubaREST()!.apiUrl +
        `v2/services/` +
        `${servicePath}?${queryParams}`,
        {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + getCubaREST()!.restApiToken,
          },
          method: "GET",
        },
      ).then((value) => {
        return value.json();
      });
    },
    getfetchWithSignal: (param: {
      lang: string;
      expression: string;
      limit: string;
      offset: string;
      servicePath: string;
      signal: AbortSignal;
    }): Promise<any> => {
      const { lang, expression, limit, offset, servicePath, signal } = param;
      const queryParams = new URLSearchParams({
        expression,
        lang,
        offset,
        limit,
      }).toString();
      return fetch(
        getCubaREST()!.apiUrl +
        `v2/services/` +
        `${servicePath}?${queryParams}`,
        {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + getCubaREST()!.restApiToken,
          },
          method: "GET",
          signal,
        },
      ).then((value) => {
        return value.json();
      });
    },

    searchPersonExtCount: (param: {
      expression: string;
      lang: string;
    }): Promise<number> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "searchPersonExtCount",
          { ...param },
        )
        .then((r: any) => {
          return JSON.parse(r);
        });
    },
    getAllPersonByCompany: (param: {
      companyCode: string;
      lang: string;
      nextOffset: number;
      limit: number;
      search: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeService",
          "getAllPersonByCompany",
          {
            ...param,
          },
        )
        .then((response) => {
          const result = JSON.parse(response);
          return JSON.parse(result[0] && result[0].value);
        });
    },
  },
  requisitionService: {
    getRequisitionTreeData: (): Promise<Array<RequisitionDataParent>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_RequisitionService",
          "getRequisitionTreeData",
          {},
        )
        .then((r) => JSON.parse(r));
    },
    sendNotificationJobRequest: (param: {
      jobRequestId: string;
      isApproval: boolean;
      comment: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_RequisitionService",
        "sendNotificationJobRequest",
        { ...param },
      );
    },
  },
  successionPlanningService: {
    getSuccessionPlannings: (param: {
      successionPlanningList: any;
      view: string;
      company?: string;
      position?: string;
      organization?: string;
      successor?: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_SuccessionPlanningService",
          "getSuccessionPlannings",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    isValidatedPosition: (param: { positionGroupId: string }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_SuccessionPlanningService",
          "isValidatedPosition",
          { ...param },
        )
        .then((r) => {
          const res = JSON.parse(r);
          return JSON.parse(res[0] && res[0]!.value!)[0];
        });
    },
    isAssessmentRequired: (params: {
      requestId: string;
      approverCode: "MANAGER" | "SUP_MANAGER";
      assessmentSessionId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_SuccessionPlanningService",
          "isAssessmentRequired",
          { ...params },
        )
        .then((res) => {
          const result = JSON.parse(res);
          if (result[0]) {
            return JSON.parse(result[0].value)[0].success;
          }
          return null;
        });
    },
    getKeyPositionCount: (companyCode: string): Promise<number> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_SuccessionPlanningService",
          "getKeyPositionCount",
          { companyCode },
        )
        .then((r) => JSON.parse(r));
    },
  },

  orgStructureService: {
    initialCreate: (personGroupId: string): Promise<OrgStructureRequest> => {
      return getCubaREST()!
        .invokeService("tsadv_OrgStructureRequestService", "initialCreate", {
          personGroupId,
        })
        .then((value: string) => JSON.parse(value));
    },
    getMergedOrgStructure: (param: {
      requestId: string;
    }): Promise<Array<OrgRequestRow>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrgStructureRequestService",
          "getMergedOrgStructure",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getOrgStructuredStructureRequestForDepartmentDirector(
      userId: string,
      viewName: string,
      querySettings: QuerySettings,
    ): Promise<EntitiesResult<OrgStructureRequest>> {
      return getCubaREST()!
        .invokeService(
          "tsadv_OrgStructureRequestService",
          "getOrgStructuredStructureRequestForDepartmentDirector",
          { userId, viewName, querySettings },
        )
        .then((value: string) => {
          const parse = JSON.parse(value);
          return {
            entities: JSON.parse(parse.entities),
            count: parse.count,
          };
        });
    },
    saveRequest: (param: {
      orgRequestSaveModel: OrgRequestSaveModel;
    }): Promise<OrgStructureRequest> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrgStructureRequestService",
          "saveRequest",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    saveOrganization: (param: {
      organizationRequestSaveModel: OrganizationSaveModel;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_OrgStructureRequestService",
        "saveOrganization",
        { ...param },
      );
    },
    savePosition: (param: {
      positionRequestSaveModel: PositionSaveModel;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_OrgStructureRequestService",
        "savePosition",
        { ...param },
      );
    },
    exclude: (param: {
      requestId: string;
      requestDetailId: string;
      elementGroupId: string;
      elementType: string;
      justification: string;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_OrgStructureRequestService",
        "exclude",
        { ...param },
      );
    },
    excludeData: (param: {
      requestId: string;
      data: OrgRequestRow;
      justification: string;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_OrgStructureRequestService",
        "exclude",
        { ...param },
      );
    },
    getGrades: (): Promise<Array<OrgRequestGrade>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrgStructureRequestService",
          "getGrades",
          null,
        )
        .then((r) => JSON.parse(r));
    },
    getMergedOrgStructureFilter: (
      param: OrgStructureFilterParams,
    ): Promise<Array<OrgRequestRow>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrgStructureRequestService",
          "getMergedOrgStructure",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    availableSalary: (personGroupId: string): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrgStructureRequestService",
          "availableSalary",
          { personGroupId },
        )
        .then((r) => JSON.parse(r));
    },
    hasPermitToCreate: (param?: {}): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrgStructureRequestService",
          "hasPermitToCreate",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getUserHasAccessToCreateOrgStructureRequest: (): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_OrgStructureRequestService",
        "getUserHasAccessToCreateOrgStructureRequest",
        {},
      );
    },
  },
  myTeamService: {
    getChildren: (param: {
      parentPositionGroupId: string;
      parent?: MyTeamNew;
    }): Promise<Array<MyTeamNew>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_MyTeamService", "getChildren", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
    getChildrenWithPosition: (param: {
      parentPositionGroupId: string;
    }): Promise<MyTeamWithEnterprise[]> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_MyTeamService", "getChildren", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
    searchMyTeam: (param: {
      parentPositionGroupId: string;
      searchFio: string;
    }): Promise<Array<MyTeamNew>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_MyTeamService", "searchMyTeam", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
  },
  hierarchyService: {
    getOrganizationChildHierarchyElement: (param: {
      parentId: string | null;
      personGroupId: string | null;
    }): Promise<Array<HierarchyElementExt>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_HierarchyService",
          "getOrganizationChildHierarchyElement",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getHeadersByBudget: (param: {
      personGroupId: string | null;
      budgetId: string;
    }): Promise<Array<SerializedEntity<HierarchyElementExt>>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_HierarchyService", "getHeadersByBudget", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
    getPositionAdditionalNameByPositionGroup(
      positionGroupsIds: string[],
    ): Promise<Map<string, string>> {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_HierarchyService",
          "getPositionAdditionalNameByPositionGroup",
          {
            positionGroupsIds,
          },
        )
        .then((r) => JSON.parse(r))
        .then((value: object) => new Map(Object.entries(value)));
    },
  },
  nationalIdentifierService: {
    checkNationalIdentifier: (param: {
      nationalIdentifier: string;
      dateOfBirth: string;
      dicSex: { id: string; code: string };
    }): Promise<Array<SerializedEntity<PersonGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_NationalIdentifierService",
          "checkNationalIdentifier",
          { ...param },
        )
        .then(r => JSON.parse(r));
    },
  },

  assignmentService: {
    getPersonGroupsByListOfOrganization: (param: {
      organizationGroupExtList: SerializedEntity<OrganizationGroupExt>[];
    }): Promise<Array<SerializedEntity<PersonGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentService",
          "getPersonGroupsByListOfOrganization",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getAssignmentsByListOfOrganization: (param: {
      organizationGroupExtList: SerializedEntity<OrganizationGroupExt>[];
    }): Promise<Array<SerializedEntity<AssignmentExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentService",
          "getAssignmentsByListOfOrganization",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  learningBudgetService: {
    setLearningBudgetRequestEmployees: async (
      learningBudgetRequestId: string,
      personGroupIdList: any,
    ) => {
      return await fetch(
        getCubaREST()!.apiUrl +
        `v2/services/kzm_LearningBudgetKzmService/setLearningBudgetRequestEmployees`,
        {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + getCubaREST()!.restApiToken,
          },
          method: "POST",
          body: JSON.stringify({ learningBudgetRequestId, personGroupIdList }),
        },
      ).then((value) => {
        return value;
      });
    },
    sendNotifyAboutSendForRevision: (param: {
      userId: string;
      responsibleUserId: string;
      url: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "sendNotifyAboutSendForRevision",
        { ...param },
      );
    },
    sendNotifyAboutSendForRevisionForecast: (param: {
      userId: string;
      responsibleUserId: string;
      url: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "sendNotifyAboutSendForRevisionForecast",
        { ...param },
      );
    },
    sendNotifyAboutApproveBudget: (param: {
      userId: string;
      responsibleUserId: string;
      learningBudgetHeaderId: string;
      url: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "sendNotifyAboutApproveBudget",
        { ...param },
      );
    },
    sendNotifyAboutApproveBudgetForecast: (param: {
      userId: string;
      responsibleUserId: string;
      learningBudgetHeaderId: string;
      url: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "sendNotifyAboutApproveBudgetForecast",
        { ...param },
      );
    },
    sendNotifyAboutDelegatingBudget: (param: {
      userId: string;
      responsibleUserId: string;
      learningBudgetHeaderId: string;
      url: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "sendNotifyAboutDelegatingBudget",
        { ...param },
      );
    },
    sendNotifyAboutDelegatingBudgetForecast: (param: {
      userId: string;
      responsibleUserId: string;
      learningBudgetHeaderId: string;
      url: string;
    }) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "sendNotifyAboutDelegatingBudgetForecast",
        { ...param },
      );
    },
    createBudgetDetailReport: (param: {
      learningBudgetId: string;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<any>(
        "tsadv_LearningBudgetService",
        "createBudgetDetailReport",
        { ...param },
      );
    },
    findReportGroupByOrganizationGroupId: (param: {
      organizationGroupId: string;
    }): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetService",
        "findReportGroupByOrganizationGroupId",
        { ...param },
      );
    },
    createBudgetHistoryApprovement: (
      learningBudgetRequestHeader: LearningBudgetRequestHeader,
      personGroupExt: PersonGroupExt,
      comment: string,
    ): Promise<void> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "createBudgetHistoryApprovement",
          { learningBudgetRequestHeader, personGroupExt, comment },
        )
        .then();
    },

    setLearningBudgetRequestAttachments: async (props: {
      learningBudgetRequestId: string;
      fileList: {
        fileDescriptorId: string;
        comment?: string | null;
      }[];
    }) => {
      return await fetch(
        getCubaREST()!.apiUrl +
        `v2/services/kzm_LearningBudgetKzmService/setLearningBudgetRequestAttachments`,
        {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + getCubaREST()!.restApiToken,
          },
          method: "POST",
          body: JSON.stringify({ ...props }),
        },
      ).then((value) => {
        return value;
      });
    },
    findCostCenterByPersonGroup: (
      personGroupId: string,
    ): Promise<DicCostCenter> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "findCostCenterByPersonGroup",
          { personGroupId },
        )
        .then((r) => r && JSON.parse(r));
    },
    findBy: (
      personFullName: string,
      organizationGroupId: string,
      querySettings: QuerySettings,
      view: string,
    ): Promise<EntitiesResult<AssignmentExt>> => {
      return getCubaREST()!
        .invokeService<string>("kzm_LearningBudgetKzmService", "findBy", {
          personFullName,
          organizationGroupId,
          querySettings,
          view,
        })
        .then((r) => JSON.parse(r));
    },

    setForecastStatus: (
      learningBudgetRequestId: string,
      forecastStatusCode: string,
    ): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "setForecastStatus",
          { learningBudgetRequestId, forecastStatusCode },
        )
        .then((r) => r);
    },

    getAssignmentsWithSuccessor: (param: {
      learningBudgetRequestId: string;
    }) => {
      return getCubaREST()!
        .invokeService<any>(
          "kzm_LearningBudgetKzmService",
          "getAssignmentsWithSuccessor",
          { learningBudgetRequestId: param },
        )
        .then((r) => {
          return JSON.parse(r);
        });
    },
    findByAssignmentsWithSuccessor: (
      personFullName: string,
      organizationGroupId: string,
      querySettings: QuerySettings,
      view: string,
    ): Promise<AssigmentFind> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "findByAssignmentsWithSuccessor",
          { personFullName, organizationGroupId, querySettings, view },
        )
        .then((r) => {
          return JSON.parse(r);
        });
    },
    findChildPositions: (
      organizationGroupId: string,
      querySettings: QuerySettings,
      name: string,
      view: string,
    ): Promise<EntitiesResult<PositionGroup>> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "findChildPositions",
          { organizationGroupId, querySettings, name, view },
        )
        .then((r) => JSON.parse(r));
    },
    getRootsForPersonGroup: (
      personGroupId: string,
      budgetId: string,
    ): Promise<BudgetOrganizationStructurePojo[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "getRootsForPersonGroup",
          { personGroupId, budgetId },
        )
        .then((r) => JSON.parse(r));
    },
    getChild: (
      orgPosition: string,
      budgetId: string,
    ): Promise<BudgetOrganizationStructurePojo[]> => {
      return getCubaREST()!
        .invokeService<string>("kzm_LearningBudgetKzmService", "getChild", {
          orgPosition,
          budgetId,
        })
        .then((r) => JSON.parse(r));
    },
    loadPathTo: (
      orgGroup: string,
      personGroup: string,
      budgetId: string,
    ): Promise<{
      items: BudgetOrganizationStructurePojo[];
      path: string[];
    }> => {
      return getCubaREST()!
        .invokeService<string>("kzm_LearningBudgetKzmService", "loadPathTo", {
          orgGroup,
          personGroup,
          budgetId,
        })
        .then((r) => JSON.parse(r));
    },
    getAvailableLearningBudgets: (
      personGroup: string,
    ): Promise<LearningBudget[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "getAvailableLearningBudgets",
          { personGroup },
        )
        .then((r) => JSON.parse(r));
    },
    makeBudgetHeader: (
      orgGroupId: string,
      budgetId: string,
    ): Promise<LearningBudgetRequestHeader> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_LearningBudgetKzmService",
          "makeBudgetHeader",
          { orgGroupId, budgetId },
        )
        .then((r) => JSON.parse(r));
    },
  },
  userService: {
    findUsers(name: string, viewName: string): Promise<TsadvUser[]> {
      return getCubaREST()!
        .invokeService<string>("tsadv_UserService", "findUsers", {
          name,
          viewName,
        })
        .then((r) => JSON.parse(r));
    },
    setWhatsAppForCurrentUser: (number: string): Promise<any> => {
      return getCubaREST()!.invokeService(
        "tsadv_UserService",
        "setWhatsAppForCurrentUser",
        { number },
      );
    },
  },
  organizationHrUserService: {
    isManagerOrSupManager: (param: {
      userId: string;
      employeePersonGroupId: string;
    }): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrganizationHrUserService",
          "isManagerOrSupManager",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getDicHrRoles: (params: { userId: string }): Promise<DicHrRole[]> => {
      return getCubaREST()!
        .invokeService("tsadv_OrganizationHrUserService", "getDicHrRoles", {
          ...params,
        })
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    getHrUsersForPerson: (param: {
      personGroupId: string;
      roleCode: string | null;
    }): Promise<TsadvUser[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrganizationHrUserService",
          "getHrUsersForPerson",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getHrUsersForPosition: (param: {
      positionGroupId: string;
      roleCode: string | null;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrganizationHrUserService",
          "getHrUsersForPosition",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getOrganizationList: (params: {
      userId: string;
      roleCode: string;
      date: string;
    }): Promise<Array<OrganizationGroupExt>> => {
      return getCubaREST()!
        .invokeService(
          "tsadv_OrganizationHrUserService",
          "getOrganizationList",
          {
            ...params,
          },
        )
        .then((response: string) => {
          return JSON.parse(response);
        });
    },
    getManagerByOrganizationGroupId: (param: {
      organizationGroupId: string;
      roleCode: string;
    }): Promise<SerializedEntity<PersonGroupExt>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrganizationHrUserService",
          "getManagerByOrganizationGroupId",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  userSettingService: {
    saveSetting: (name: string, value: string): void => {
      getCubaREST()!.invokeService<string>(
        "cuba_UserSettingService",
        "saveSetting",
        {
          clientType: "P",
          name: name,
          value: value,
        },
      );
    },
    loadSetting: <T>(name: string): Promise<T> => {
      return getCubaREST()!
        .invokeService<string>("cuba_UserSettingService", "loadSetting", {
          clientType: "P",
          name: name,
        })
        .then((value) => (!value ? {} : JSON.parse(value)));
    },
  },
  positionService: {
    getManager: (positionGroupId: string): Promise<PositionGroupExt> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_PositionService", "getManager", {
          positionGroupId: positionGroupId,
        })
        .then((value) => JSON.parse(value));
    },
    getPositionInfo: (
      positionGroupId: string,
      date: string,
    ): Promise<PositionInfo> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_PositionService", "getPositionInfo", {
          positionGroupId: positionGroupId,
          date: date,
        })
        .then((value) => JSON.parse(value));
    },
    getPositionInfoKms: (
      positionGroupId: string,
    ): Promise<PositionInfo> => {
      return getCubaREST()!
        .invokeService<string>("kms_PositionService", "getPositionInfoKms", {
          positionGroupId: positionGroupId,
        })
        .then((value) => JSON.parse(value));
    },
    getChildPositions: (
      date: string,
      view: string,
    ): Promise<PositionGroupExt> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_PositionService", "getChildPositions", {
          date: date,
          view: view,
        })
        .then((value) => JSON.parse(value));
    },
    getActiveChildPositions: (
      date: string,
      view: string,
    ): Promise<SerializedEntity<PositionGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PositionService",
          "getActiveChildPositions",
          { date: date, view: view },
        )
        .then((value) => JSON.parse(value));
    },
  },
  employeeNumberService: {
    generateNextRequestNumber: (): Promise<number> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeNumberService",
          "generateNextRequestNumber",
          {},
        )
        .then((value) => JSON.parse(value));
    },
  },
  executiveAssistantService: {
    getManagerList: (
      assistantPositionGroupId: string,
    ): Promise<PersonProfile[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_ExecutiveAssistantService",
          "getManagerList",
          {
            assistantPositionGroupId: assistantPositionGroupId,
          },
        )
        .then((value) => JSON.parse(value));
    },
    getManagerListWithoutAssignment: (
      assistantPositionGroupId: string,
    ): Promise<PersonProfile[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_ExecutiveAssistantService",
          "getManagerListWithoutAssignment",
          {
            assistantPositionGroupId: assistantPositionGroupId,
          },
        )
        .then((value) => JSON.parse(value));
    },
    getManagerListWithoutClosedPosition: (
      assistantPositionGroupId: string,
    ): Promise<PersonProfile[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_ExecutiveAssistantService",
          "getManagerListWithoutClosedPosition",
          {
            assistantPositionGroupId: assistantPositionGroupId,
          },
        )
        .then((value) => JSON.parse(value));
    },
  },
  reports: {
    refreshBell: (params: { userId: string }): Promise<ReportResponse> => {
      return getCubaREST()!
        .invokeService<string>("kzm_UactivityService", "refreshBell", params)
        .then((response) => response && JSON.parse(response));
    },

    loadReportByCode: (reportCode: string): Promise<Report> => {
      return getCubaREST()!
        .searchEntities<Report>(
          Report.NAME,
          {
            conditions: [
              {
                property: "code",
                operator: "=",
                value: reportCode,
              },
              {
                property: "restAccess",
                operator: "=",
                value: "TRUE",
              },
            ],
          },
          {
            limit: 1,
          },
        )
        .then((value) => {
          if (value && value.length === 1) return value[0];
          throw new Error("report[" + reportCode + "] not found!");
        });
    },
    run: async (
      reportId: string,
      data: any,
      catchException?: (reason: any) => void,
    ) => {
      return await fetch(getCubaREST()!.apiUrl + `reports/v1/run/${reportId}`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + getCubaREST()!.restApiToken,
        },
        method: "POST",
        body: JSON.stringify(data),
      })
        .then((value) => {
          if (value.ok) {
            const contentDisposition = decodeURIComponent(
              value.headers.get("Content-Disposition") || "",
            );
            const fileName = contentDisposition.split("\"")[1];
            value.blob().then((blobUrl) => saveFile(blobUrl, fileName));
          }
          return value;
        })
        .catch((reason) => {
          if (catchException) catchException(reason);
        });
    },
    runFetch: async (reportId: string, data: any) => {
      return await fetch(getCubaREST()!.apiUrl + `reports/v1/run/${reportId}`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + getCubaREST()!.restApiToken,
        },
        method: "POST",
        body: JSON.stringify(data),
      }).then((value) => {
        if (value.ok) {
          const contentDisposition = decodeURIComponent(
            value.headers.get("Content-Disposition") || "",
          );
          const fileName = contentDisposition.split("\"")[1];
          value.blob().then((blobUrl) => saveFile(blobUrl, fileName));
          return value;
        }
        throw Error();
      });
    },
  },
  ucoSign: {
    getfetch: (param: string, serviceName: string): Promise<any> => {
      return fetch(getCubaREST()!.apiUrl + `sign/${serviceName}?${param}`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + getCubaREST()!.restApiToken,
        },
        method: "GET",
      }).then((value) => {
        return value.json();
      });
    },

    postFetch: async (
      data: any,
      serviceName: string,
      signal: AbortSignal,
    ): Promise<any> => {
      try {
        const response = await fetch(
          getCubaREST()!.apiUrl + `sign/${serviceName}`,
          {
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              Authorization: "Bearer " + getCubaREST()!.restApiToken,
            },
            method: "POST",
            body: JSON.stringify(data),
            signal,
          },
        );

        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Произошла ошибка:", error);
        throw error;
      }
    },
  },
  commonReportsService: {
    downloadReportByCode: (params: {
      reportCode: string;
      entityId: string;
      entityParamName: string;
    }): Promise<ReportResponse> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_CommonReportsService",
          "downloadReportByCode",
          params,
        )
        .then((response) => JSON.parse(response));
    },
  },
  vacationScheduleRequestService: {
    approveVacationRequest: (params: {
      vacations: string[];
    }): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_VacationScheduleRequestService",
        "approveVacationRequest",
        params,
      );
    },
    getVacationScheduleBalanceDays: (params: {
      vacation: VacationPojo;
    }): Promise<number> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "getVacationScheduleBalanceDays",
          params,
        )
        .then((value) => JSON.parse(value));
    },
    ganttChart: (
      startDate: string,
      endDate: string,
    ): Promise<Array<GanttChartVacationScheduleData>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "ganttChart",
          {
            startDate: startDate,
            endDate: endDate,
          },
        )
        .then((value) => JSON.parse(value));
    },
    getChildVacationSchedule: (
      querySettings: QuerySettings,
    ): Promise<EntitiesResult<VacationScheduleRequest>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "getChildVacationSchedule",
          {
            querySettings: querySettings,
          },
        )
        .then((value) => {
          const parse = JSON.parse(value);
          return {
            entities: JSON.parse(parse.entities),
            count: parse.count,
          };
        });
    },
    getPositionChildVacationSchedule: (
      querySettings: QuerySettings,
      positionGroupId: string,
    ): Promise<EntitiesResult<VacationScheduleRequest>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "getChildVacationSchedule",
          {
            querySettings: querySettings,
            positionGroupId: positionGroupId,
          },
        )
        .then((value) => {
          const parse = JSON.parse(value);
          return {
            entities: JSON.parse(parse.entities),
            count: parse.count,
          };
        });
    },
    filterEmployees: (param: {
      positionGroupId: string;
      date: string;
      view: string;
      isAssistant: boolean;
    }): Promise<Array<SerializedEntity<PersonGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "filterEmployees",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    filterPositions: (param: {
      positionGroupId: string;
      date: string;
      view: string;
      isAssistant: boolean;
    }): Promise<Array<SerializedEntity<PositionGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "filterPositions",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    filterOrganizations: (param: {
      positionGroupId: string;
      date: string;
      view: string;
      isAssistant: boolean;
    }): Promise<Array<SerializedEntity<OrganizationGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacationScheduleRequestService",
          "filterOrganizations",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getPositionHierarchyPath: (param: {
      positionGroupId: any;
      lang?: any | null;
      date?: any | null;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_PositionService",
          "getPositionHierarchyPath",
          { ...param },
        )
        .then((r) => r);
    },
    sendToRevision: (params: {
      vacationScheduleDataJson: any;
      commentManager: string;
    }): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_VacationScheduleRequestService",
        "sendToRevision",
        params,
      );
    },
  },
  bpmUserSubstitutionService: {
    save: (bpmUserSubstitution: BpmUserSubstitution): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_BpmUserSubstitutionService", "save", {
          bpmUserSubstitution: bpmUserSubstitution,
        })
        .then((value) => JSON.parse(value));
    },
  },
  incentiveService: {
    getIncentiveList: (args: {
      pagination: QuerySettings;
      orgName?: string;
      date?: string | Moment;
    }): Promise<EntitiesResult<GanttChartVacationScheduleData>> => {
      const { pagination, orgName = "", date = "" } = args;

      return getCubaREST()!
        .invokeService<string>("tsadv_IncentiveService", "getIncentiveList", {
          querySettings: pagination,
          orgName,
          date,
        })
        .then((value) => {
          const parse = JSON.parse(value);
          return {
            entities: JSON.parse(parse.entities),
            count: parse.count,
          };
        });
    },
    getIncentiveListActive: (args: {
      pagination: QuerySettings;
      orgName?: string;
    }): Promise<EntitiesResult<GanttChartVacationScheduleData>> => {
      const { pagination, orgName = "" } = args;
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_IncentiveService",
          "getIncentiveListActive",
          {
            querySettings: pagination,
            orgName,
          },
        )
        .then((value) => {
          const parse = JSON.parse(value);
          return {
            entities: JSON.parse(parse.entities),
            count: parse.count,
          };
        });
    },

    saveMonthResult: (
      status: string,
      comment: string,
      incentiveMonthResultId: string,
    ) => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_IncentiveService",
        "saveMonthResult",
        {
          status: status,
          comment: comment,
          incentiveMonthResultId: incentiveMonthResultId,
        },
      );
    },
  },
  assignmentSalaryRequestService: {
    getAssignmentSalaryInfo: async (params: {
      date: any;
      personGroupId: string;
    }): Promise<AssignmentSalaryPojo> => {
      return await getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentSalaryRequestService",
          "getAssignmentSalaryInfo",
          params,
        )
        .then((value) => JSON.parse(value));
    },
    getMyOrgAndChilds: (): Promise<Array<OrganizationGroup>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentSalaryRequestService",
          "getMyOrgAndChilds",
          {},
        )
        .then((r) => JSON.parse(r));
    },
    getTypeForWccf: (entityId: string): Promise<WccfType> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentSalaryRequestService",
          "getTypeForWccf",
          { entityId },
        )
        .then((r) => r as WccfType);
    },
    findPerson: (
      fullName: string,
      companyCode: string,
      view: string,
    ): Promise<PersonGroupExt[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentSalaryRequestService",
          "findPerson",
          { fullName, companyCode, view },
        )
        .then((r) => JSON.parse(r));
    },
    getListByConflictOfInterest: (
      personGroupId: string,
      organizationGroupId: string,
    ): Promise<string[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentSalaryRequestService",
          "getListByConflictOfInterest",
          { personGroupId, organizationGroupId },
        )
        .then((r) => JSON.parse(r));
    },
  },
  jobDescriptionService: {
    getJobDescriptionRequests: (param: {
      positionId: string;
    }): Promise<Array<JobDescriptionRequestJson>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_JobDescriptionService",
          "getJobDescriptionRequests",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  annualSalaryRevisionService: {
    getSalaryRevisionPerson: (param: {
      salaryRevisionId: string;
      lang: string;
      salaryRevisionRequestId: string | null;
      limit: number;
      nextOffset: number;
      filterOf: string;
      fullNameSearch: string;
      positionNameSearch: string;
      organizationNameSearch: string;
      departmentSearch: string;
      subDepartmentSearch: string;
      gradeSearch: string;
    }): Promise<string[]> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_AnnualSalaryRevisionService",
          "getSalaryRevisionPerson",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    importForAsr: (param: { fileDescriptorId: string }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_AnnualSalaryRevisionService",
          "importForAsr",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getSalaryRevisionTotals: (param: {
      salaryRevisionId: string;
      asrRequestId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_AnnualSalaryRevisionService",
          "getSalaryRevisionTotals",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    sendCbNotification: (param: {
      asr: string;
      approve: boolean;
    }): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<boolean>(
          "tsadv_AnnualSalaryRevisionService",
          "sendCbNotification",
          { ...param },
        )
        .then((r) => r);
    },
    getSalaryRevisionRequestJson: (param: {
      positionGroupId: string;
      lang: string;
      limit: number;
      nextOffset: number;
      filterOf: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_AnnualSalaryRevisionService",
          "getSalaryRevisionRequestJson",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  positionStructureService: {
    getChildren: (param: {
      parentId: string;
    }): Promise<Array<PositionHierarchy>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PositionStructureService",
          "getChildren",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getStartData: (param: {}): Promise<Array<PositionHierarchy>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PositionStructureService",
          "getStartData",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },

    getPositionDetails: (param: {
      positionGroupId: string;
    }): Promise<PositionGroupDetails> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PositionStructureService",
          "getPositionDetails",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getOrganizationHierarchyTree: (param: {
      organizationGroupId: string;
    }): Promise<string> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PositionStructureService",
          "getOrganizationHierarchyTree",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getStructureChildren: (
      positionId: string,
      name?: string,
    ): Promise<PositionStructurePojo[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PositionStructureService",
          "getStructureChildren",
          { positionId, name },
        )
        .then((r) => JSON.parse(r));
    },
  },
  successorService: {
    getSuccessorsByPosition: async (param: {
      positionGroupId: string;
      date: string;
    }): Promise<Array<PositionHierarchy>> => {
      return await getCubaREST()!
        .invokeService<string>(
          "tsadv_SuccessorService",
          "getSuccessorsByPosition",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  punishmentService: {
    getPunishmentByPersonGroup: (param: {
      personGroupId: string;
    }): Promise<Array<Punishment>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PunishmentService",
          "getPunishmentByPersonGroup",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getPunishmentByIds: (param: {
      ids: string[];
    }): Promise<Array<PunishmentKzm>> => {
      return getCubaREST()!
        .invokeService<string>("kzm_PunishmentService", "getPunishmentByIds", {
          ...param,
        })
        .then((r) => JSON.parse(r));
    },
  },
  assignmentScheduleService: {
    getAssignmentSchedule: (param: {
      personGroupId: string;
      date: string;
      view: string;
    }): Promise<SerializedEntity<AssignmentSchedule>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AssignmentScheduleService",
          "getAssignmentSchedule",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  employeeHierarchyService: {
    getChildEmployees: (param: {
      positionGroupId: string;
      date: string;
      view: string;
    }): Promise<Array<SerializedEntity<PersonGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeHierarchyService",
          "getChildEmployees",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getChildPositions: (param: {
      positionGroupId: string;
      date: string;
      view: string;
    }): Promise<Array<SerializedEntity<PositionGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeHierarchyService",
          "getChildPositions",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getChildPositionOrganizations: (param: {
      positionGroupId: string;
      date: string;
      view: string;
    }): Promise<Array<SerializedEntity<OrganizationGroupExt>>> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_EmployeeHierarchyService",
          "getChildPositionOrganizations",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getPositionHierarchyPath: (
      positionGroupId: string,
      lang?: string,
      date?: any,
    ): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_PositionService",
          "getPositionHierarchyPath",
          positionGroupId,
        )
        .then((r) => JSON.parse(r));
    },
  },
  positionHierarchyService: {
    getPositionHierarchyPath: (param: {
      positionGroupId: any;
      lang?: any | null;
      date?: any | null;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<any>(
          "tsadv_PositionService",
          "getPositionHierarchyPath",
          { ...param },
        )
        .then((r) => r);
    },
  },
  hrService: {
    getEmployers: (): Promise<SerializedEntity<PersonGroupExt>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_HrService", "getEmployers", {})
        .then((r) => JSON.parse(r));
    },
    isHr: (): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_HrService", "isHr", {})
        .then((r) => JSON.parse(r));
    },
  },
  dismissalService: {
    saveUserFeedback: (
      params: {
        templateId: string;
        personGroupId: string;
        questionsAndAnswers: AnsweredQuestion[];
      },
      fetchOpts?: FetchOptions,
    ) => {
      return getCubaREST()!.invokeService(
        "tsadv_DismissalService",
        "saveUserFeedback",
        { ...params },
        fetchOpts,
      );
    },
    getDismissalRequest: (params: {
      personGroupId: string;
    }): Promise<DismissalRequest> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_DismissalService",
          "getDismissalRequest",
          { ...params },
        )
        .then((r) => JSON.parse(r));
    },
    existExitInterview: (params: {
      personGroupId: string;
    }): Promise<string> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_DismissalService", "existExitInterview", {
          ...params,
        })
        .then((r: string) => r);
    },
  },
  learningBudgetPortalService: {
    loadBudgetApprovmentData: async (
      learningBudgetId: string,
    ): Promise<TableDataParent[]> => {
      const resp = await getCubaREST()!.invokeService<string>(
        "tsadv_LearningBudgetPortalService",
        "loadLearningBudgetData",
        {
          learningBudgetId: learningBudgetId,
        },
      );
      return await JSON.parse(resp);
    },
  },
  organizationService: {
    loadOrganizationTree: (
      params: {
        parentId: string | null;
        hierarchyId: string | null;
        searchText: string | null;
      },
      fetchOpts?: FetchOptions,
    ): Promise<OrganizationTree[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_OrganizationService",
          "loadOrganizationTree",
          { ...params },
          fetchOpts,
        )
        .then((r) => JSON.parse(r));
    },
  },
  scoredCompetencyService: {
    getScorecardData: (param: { assignmentId: string }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PersonCompetenceService",
          "getScorecardData",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getScorecardHistoryData: (param: {
      assignmentId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PersonCompetenceService",
          "getScorecardHistoryData",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    calcResult: (param: { assignmentId: string }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_PersonCompetenceService", "calcResult", {
          ...param,
        })
        .then((r) => r);
    },
  },
  userHelperService: {
    getUsersFullName: async (logins: string[]): Promise<string[]> => {
      const r = await getCubaREST()!.invokeService<string>(
        "tsadv_UserHelperService",
        "getUsersFullName",
        {
          logins: logins,
        },
      );
      return JSON.parse(r);
    },
  },
  portalFeedbackQuestionAnswerService: {
    getByQuestionId: (
      questionId: string,
    ): Promise<Array<PortalFeedbackQuestionAnswer>> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_PortalFeedbackQuestionAnswerService",
          "getByQuestionId",
          { questionId: questionId },
        )
        .then((r) => JSON.parse(r));
    },
    save: (param: { entity: PortalFeedbackQuestionAnswer }): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "kzm_PortalFeedbackQuestionAnswerService",
        "save",
        { ...param },
      );
    },
  },
  vacancyRequestService: {
    getAssistantManagers: (): Promise<SerializedEntity<PersonGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacancyRequestService",
          "getAssistantManagers",
          {},
        )
        .then((r) => JSON.parse(r));
    },
    getChildPositionGroups: (
      personGroupId: string,
    ): Promise<SerializedEntity<PositionGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacancyRequestService",
          "getChildPositionGroups",
          { personGroupId: personGroupId },
        )
        .then((r) => JSON.parse(r));
    },
    hasAssistantManager: (entity: AbstractBprocRequest): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<boolean>(
          "tsadv_VacancyRequestService",
          "hasAssistantManager",
          { entity: entity },
        )
        .then((r) => r);
    },
    postVacancy: (vacancyRequest: VacancyRequest): Promise<void> => {
      return getCubaREST()!
        .invokeService<void>("tsadv_VacancyRequestService", "postVacancy", {
          vacancyRequest: vacancyRequest,
        })
        .then((r) => r);
    },
    getListSubstituter: (param: {
      positionGroupId: string;
    }): Promise<SerializedEntity<PersonGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_VacancyRequestService",
          "getListSubstituter",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  surChargeRequestService: {
    revision: (param: { entityId: string }): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_SurChargeService",
        "revision",
        { ...param },
      );
    },
  },
  adaptationPlanRequestService: {
    //return -> FileDescriptor
    getJobInstructions: (
      personGroupId: string,
    ): Promise<SerializedEntity<FileDescriptor> | null> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AdaptationService",
          "getJobInstructions",
          { personGroupId },
        )
        .then((r) => {
          return r ? JSON.parse(r) : null;
        });
    },
    //return -> PersonGroup
    getManager: async (
      personGroupId: string,
    ): Promise<SerializedEntity<PersonGroupExt>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_AdaptationService", "getManager", {
          id: personGroupId,
        })
        .then((r) => JSON.parse(r));
    },
    //return -> DocumentsFamiliarization
    getDocumentsForReview: (
      adaptationPlanId: string,
    ): Promise<SerializedEntity<DocumentsFamiliarization>[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AdaptationService",
          "getDocumentsForReview",
          { entityId: adaptationPlanId },
        )
        .then((r) => JSON.parse(r));
    },
    //return -> PositionCourse
    getPositionCourse: (
      adaptationPlanId: string,
    ): Promise<SerializedEntity<PositionCourse>[]> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_AdaptationService", "getPositionCourse", {
          entityId: adaptationPlanId,
        })
        .then((r) => JSON.parse(r));
    },
    //return -> PersonGroup
    getHrs: (): Promise<SerializedEntity<PersonGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_AdaptationService", "getHrs", {})
        .then((r) => JSON.parse(r));
    },
    //return -> PersonGroup
    getManagers: async (
      personGroupId: string,
    ): Promise<SerializedEntity<PersonGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_AdaptationService", "getManagers", {
          id: personGroupId,
        })
        .then((r) => JSON.parse(r));
    },
    //return -> PersonGroup
    getEmployeeCompanyHrs: (
      personGroupId: string,
    ): Promise<SerializedEntity<PersonGroupExt>[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_AdaptationService",
          "getEmployeeCompanyHrs",
          { id: personGroupId },
        )
        .then((r) => JSON.parse(r));
    },
    getAssessmentByAdaptationPlan: async (params: {
      adaptationPlanId: string;
      lang: string;
    }): Promise<AdaptationServiceGetAssessmentResult[]> => {
      try {
        const res = await getCubaREST()!.invokeService<string>(
          "tsadv_AdaptationService",
          "getAssessmentByAdaptationPlan",
          { ...params },
        );
        const data: null | { type: string; value: string } = res
          ? JSON.parse(res)
          : null;
        if (data && data.type === "json") {
          return JSON.parse(data.value);
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    getAssessment: async (params: {
      personGroupId: string;
      lang: string;
    }): Promise<AdaptationServiceGetAssessmentResult[]> => {
      try {
        const res = await getCubaREST()!.invokeService<string>(
          "tsadv_AdaptationService",
          "getAssessment",
          { ...params },
        );
        const data: null | { type: string; value: string } = res
          ? JSON.parse(res)
          : null;
        if (data && data.type === "json") {
          return JSON.parse(data.value);
        }
        return [];
      } catch (error) {
        return [];
      }
    },
  },
  recognitionPortalService: {
    loadUserMedals: async (
      personGroupId: string,
    ): Promise<Array<PersonMedal>> => {
      const resp = await getCubaREST()!.invokeService<string>(
        "tsadv_RecognitionPortalService",
        "loadUserMedals",
        {
          personGroupId: personGroupId,
        },
      );

      return JSON.parse(resp);
    },
    loadUserNominations: async (
      personGroupId: string,
    ): Promise<Array<PersonMedalRequest>> => {
      const resp = await getCubaREST()!.invokeService<string>(
        "tsadv_RecognitionPortalService",
        "loadUserNominations",
        {
          personGroupId: personGroupId,
        },
      );

      return JSON.parse(resp);
    },
  },
  JobOfferRequestService: {
    //987
    getManagers: (
      params: { id: string },
      fetchOpts?: FetchOptions,
    ): Promise<any> => {
      return getCubaREST()!.invokeService(
        "tsadv_JobOfferService",
        "getManagers",
        { ...params },
        fetchOpts,
      );
    },
  },
  userRegistrationService: {
    getPersonByIinAndMobilePhone: (
      iin: string,
      mobilePhone: string,
    ): Promise<{ error?: "IIN"; personGroupExt: PersonGroupExt }> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_UserRegistrationService",
          "getPersonByIinAndMobilePhone",
          { iin, mobilePhone },
        )
        .then((r) => ("" === r ? null : JSON.parse(r)));
    },
    getUserByIin: (iin: string): Promise<BaseUserExt> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_UserRegistrationService",
          "getUserByIin",
          { iin: iin },
        )
        .then((r) => JSON.parse(r));
    },
    sendSms: (person: string, mobile: string): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_UserRegistrationService", "sendSms", {
          person: person,
          mobile: mobile,
        })
        .then((r) => JSON.parse(r));
    },
    testSms: (person: string, code: string): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_UserRegistrationService", "testSms", {
          person: person,
          code: code,
        })
        .then((r) => JSON.parse(r));
    },
    createUser: (person: string, password: string): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_UserRegistrationService", "createUser", {
          person: person,
          password: password,
        })
        .then((r) => r && JSON.parse(r));
    },
    updatePassword: (person: string, password: string): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_UserRegistrationService",
          "updatePassword",
          { person: person, password: password },
        )
        .then((r) => JSON.parse(r));
    },
    getSmsCodeTimeoutSec: (): Promise<number> => {
      return getCubaREST()!
        .invokeService<number>(
          "tsadv_UserRegistrationService",
          "getSmsCodeTimeoutSec",
          {},
        )
        .then((r) => {
          if (!r) return 300;
          else return r.valueOf();
        })
        .catch(
          action(() => {
            return 300;
          }),
        );
    },
    checkLatinName: (iin: string): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_UserRegistrationService",
          "checkLatinName",
          { iin: iin },
        )
        .then((r) => JSON.parse(r));
    },
  },
  learningRequestService: {
    approveTd: (params: {
      approvePojo: ApproveTd;
      request: AbstractBprocRequest;
      taskData: ExtTaskData;
    }): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_LearningRequestService",
        "approveTd",
        { ...params },
      );
    },
  },
  personAssessmentService: {
    deleteById: (params: { personAssessmentId: string }): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_PersonAssessmentService",
        "deleteById",
        { ...params },
      );
    },
  },
  gradeDetailService: {
    saveGradeDetail: (
      gradeDetail: GradeDetail,
      gradeDetailAnswers: GradeDetailAnswer[],
    ): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_GradeDetailService",
        "saveGradeDetail",
        { gradeDetail, gradeDetailAnswers },
      );
    },
    updateGradeDetail: (
      gradeDetail: GradeDetail,
      gradeDetailAnswers: any[],
      currentGradeDetailId: string,
    ): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "kzm_GradeDetailKzmService",
        "updateGradeDetail",
        { gradeDetail, gradeDetailAnswers, currentGradeDetailId },
      );
    },
    needShowLog: (): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_UserErrorSettingsService",
          "needShowLog",
          {},
        )
        .then((r) => JSON.parse(r));
    },
  },
  personSearchService: {
    searchByMultiLocalFIONumberCompany(
      searchStr: string,
      viewName: string,
    ): Promise<PersonExt[]> {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PersonSearchService",
          "searchByMultiLocalFIONumberCompany",
          { searchStr, viewName },
        )
        .then((r) => JSON.parse(r));
    },
  },
  jobOfferServiceKzm: {
    getReportsByCompany: (companyCode: string): Promise<string[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_JobOfferServiceKzService",
          "getReportsByCompany",
          { companyCode },
        )
        .then((r) => JSON.parse(r));
    },
  },
  recognitionFindService: {
    findBy: (
      assignmentFindPojo: {
        name: string | null;
        position: string | null;
        department: string | null;
        employeeNumber: string | null;
        company: string | null;
        organizationGroupId: string;
      },
      querySettings: QuerySettings,
      view: string,
    ): Promise<EntitiesResult<AssignmentExt>> => {
      return getCubaREST()!
        .invokeService<string>("tsadv_RecognitionFindService", "findBy", {
          assignmentFindPojo,
          querySettings,
          view,
        })
        .then((r) => JSON.parse(r));
    },
  },
  personMedalRequest2PersonGroupLinkService: {
    make: (
      personGroupExt: PersonGroupExt,
    ): Promise<PersonMedalRequest2PersonGroupLink> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_PersonMedalRequest2PersonGroupLinkService",
          "make",
          { personGroupExt },
        )
        .then((r) => JSON.parse(r));
    },
  },
  userErrorSettingsService: {
    changeShowLog: (showLog: boolean): Promise<void> => {
      return getCubaREST()!.invokeService<void>(
        "tsadv_UserErrorSettingsService",
        "changeShowLog",
        { showLog },
      );
    },
    needShowError: (): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_UserErrorSettingsService",
          "needShowError",
          {},
        )
        .then((r) => JSON.parse(r));
    },
  },
  learningBudgetRequestService: {
    calculateCosts: (calculate: CalculateData): Promise<CalculateResult> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_LearningBudgetRequestService",
          "calculateCosts",
          { calculate },
        )
        .then((r) => JSON.parse(r));
    },
    calculateNazCost: (
      perdiemsSettingsId: string | null,
      dayCount: number,
    ): Promise<CalculateNationalResult> => {
      return getCubaREST()!
        .invokeService<string>(
          "tsadv_LearningBudgetRequestService",
          "calculateNazCost",
          { perdiemsSettingsId, dayCount },
        )
        .then((r) => JSON.parse(r));
    },
  },
  mentorService: {
    getMyTeamMentors: async (param: {
      parentPositionGroupId: string;
    }): Promise<Array<Mentor>> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kzm_MentorService",
        "getMyTeamMentors",
        {
          ...param,
        },
      );
      return JSON.parse(r);
    },
    getOffsetScheduleName: async (param: {
      parentGroupId: string;
    }): Promise<string> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kzm_MentorService",
        "getOffsetScheduleName",
        {
          ...param,
        },
      );
      return JSON.parse(r);
    },
    getMentorsByCompanyId: async (param: {
      companyId: string;
    }): Promise<Array<Mentor>> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kzm_MentorService",
        "getMentorsByCompanyId",
        {
          ...param,
        },
      );
      return JSON.parse(r);
    },
  },
  personMentorService: {
    getCurrentMentor: async (param: {
      personGroupId: string;
      mentorshipRequestTypeId: string;
    }): Promise<PersonMentorKzm> => {
      return getCubaREST()!
        .invokeService<string>("kzm_PersonMentorService", "getCurrentMentor", {
          ...param,
        })
        .then((r) => JSON.parse(r))
        .catch(() => null);
    },
    getMentors: async (param: {
      personGroupId: string;
    }): Promise<SerializedEntity<PersonMentorKzm>[]> => {
      return getCubaREST()!
        .invokeService<string>("kzm_PersonMentorService", "getMentors", {
          ...param,
        })
        .then((r) => JSON.parse(r))
        .catch(() => null);
    },
  },
  kms_RcApiService: {
    createJobRequest: async (params: {
      vacancyId: string;
      candidateId: string;
      linkedin: string;
    }): Promise<any> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kms_RcApiService",
        "createJobRequest",
        { ...params },
      );
      return r && JSON.parse(r);
    },
    getVacanciesInner: async (
      params: GetVacanciesInnerParams,
    ): Promise<ResponseVacancy> => {
      const {
        code = "",
        vacancyName = "",
        cityId = "",
        categoryId = "",
        lang = "",
        predpriatieId,
        companyId = "",
      } = params;

      const r = await getCubaREST()!.invokeService<string>(
        "kms_RcApiService",
        "getVacanciesInner",
        {
          code,
          vacancyName,
          cityId,
          categoryId,
          lang,
          predpriatieId,
          companyId,
        },
      );
      return r && JSON.parse(r);
    },
    getVacancy: async (params: GetVacancyParams): Promise<IVacancyInfo> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kms_RcApiService",
        "getVacancy",
        { ...params },
      );
      return r && JSON.parse(r);
    },

    getCities: async (): Promise<ResponseCity> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kms_RcApiService",
        "getCities",
        {},
      );
      return r && JSON.parse(r);
    },
    getCategories: async (): Promise<ResponseCategory> => {
      const r = await getCubaREST()!.invokeService<string>(
        "kms_RcApiService",
        "getCategories",
        {},
      );
      return r && JSON.parse(r);
    },
  },
  digitalSignatureSignService: {
    getAvailabilitySignList: (params: { userId: string; registrationIds: string[] }): Promise<boolean> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_DigitalSignatureKzmService",
        "getAvailabilitySignList",
        params,
      ).then(r => JSON.parse(r));
    },
    getListOfDocumentsToSign: (params: { userId: string }) => {
      return getCubaREST()!.invokeService(
        "kzm_DigitalSignatureKzmService",
        "getListOfDocumentsToSign",
        params,
      );
    },
    getListDtoOfDocumentsToSign: (params: { userId: string }) => {
      return getCubaREST()!.invokeService(
        "kzm_DigitalSignatureKzmService",
        "getListDtoOfDocumentsToSign",
        params,
      );
    },
    getApproversForDocument: (params: { documentId: string }) => {
      return getCubaREST()!.invokeService(
        "kzm_DigitalSignatureKzmService",
        "getApproversForDocument",
        params,
      );
    },
    getAllDocumentsWithSignal: async (
      params: {
        userId: string;
        filter: string;
        signal: AbortSignal;
        servicePath: string;
        querySettings: { limit: number; offset: number };
        typeRegistration: ITypeRegistration;
      }): Promise<{ count: number; entities: ucoSignRegistrationWithName[] }> => {
      const { signal, servicePath, querySettings, typeRegistration = "", ...args } = params;

      const bodyParams = {
        ...args,
        typeRegistration,
        querySettings,
      };

      return fetch(`${getCubaREST()!.apiUrl}v2/services/${servicePath}`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + getCubaREST()!.restApiToken,
        },
        method: "POST",
        body: JSON.stringify(bodyParams),
        signal,
      }).then(response => response.json());
    },
    getAllDocuments: (
      params: {
        userId: string;
        filter?: string;
        querySettings: { limit: number; offset: number };
        typeRegistration: ITypeRegistration;
      }): Promise<{ count: number; entities: ucoSignRegistrationWithName[] }> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_DigitalSignatureKzmService",
        "getAllDocuments",
        params,
      ).then(r => JSON.parse(r));
    },
    getRegistrationWithEntityId: (params: {
      entityId: string;
    }): Promise<UcoSignRegistration[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_DigitalSignatureKzmService",
          "getRegistrationWithEntityId",
          params,
        )
        .then((r) => JSON.parse(r));
    },
    getAvailabilitySign: (params: {
      userId: string;
      registrationId: string;
    }): Promise<boolean> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_DigitalSignatureKzmService",
          "getAvailabilitySign",
          params,
        )
        .then((r) => JSON.parse(r));
    },

    getHistoryRegistrationById: (params: {
      registrationId: string;
    }): Promise<any> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_DigitalSignatureKzmService",
          "getHistoryRegistrationById",
          params,
        )
        .then((r) => JSON.parse(r));
    },
  },
  PayslipListFileService: {
    getPayslipListFile: (personPayslipId: string): Promise<string> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_PayslipListFileService",
        "getPayslipListFile",
        { personPayslipId },
      );
    },
  },
  NewEmployeeService: {
    getNewPeopleTodayList: (param: {
      company: string;
    }): Promise<PersonGroupExt[]> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_NewEmployeeService",
          "getNewPeopleTodayList",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
    getPredpriatieByPersonGroupId: (param: {
      personGroupId: string;
    }): Promise<OrganizationWithPredpriatie> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_NewEmployeeService",
          "getPredpriatieByPersonGroupId",
          { ...param },
        )
        .then((r) => JSON.parse(r));
    },
  },
  trainingOnADayOffService: {
    validate: (param: {
      trainingOnADayOffRequestKzm: TrainingOnADayOffRequestKzm;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "kzm_TrainingOnADayOffRequestValidationService",
        "validate",
        { ...param },
      );
    },
  },
  integrationService: {
    enablePointIntegration: (param: {
      personGroupId: string;
    }): Promise<any> => {
      return getCubaREST()!.invokeService<string>(
        "tsadv_IntegrationRestService",
        "enablePointIntegration",
        { ...param, infoType: "stage" },
      );
    },
  },
  feedbackPortalQuestionsService: {
    getRequisitionData: (params: LoadPortalFeedbackQuestionsParam): Promise<FeedbackQuestionWrapper> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_FeedbackPortalQuestionsService",
          "getFeedbackPortalQuestionsData",
          params,
        )
        .then(r => JSON.parse(r));
    },
    getPortalFeedbackQuestionAnswersData: (params: LoadPortalFeedbackQuestionsAnswerParam): Promise<FeedbackQuestionAnswerDto> => {
      return getCubaREST()!
        .invokeService<string>(
          "kzm_FeedbackPortalQuestionsService",
          "getPortalFeedbackQuestionAnswersData",
          params,
        )
        .then(r => JSON.parse(r));
    },

    closeFeedbackPortalQuestion: (params: {questionId: string}):Promise<void> => {
      return getCubaREST()!.invokeService(
        "kzm_FeedbackPortalQuestionsService",
        "closeFeedbackPortalQuestion",
        params,
        {
          handleAs: 'json'
        }
      )
    }
  },
};

export type EntitiesPaginationResult<T> = {
  entities: Array<SerializedEntity<T>>;
  count: number;
};
export type ucoSignRegistrationWithName = {
  fullName: string;
  ucoSignRegistration: UcoSignRegistration;
};
export type AssigmentFind = {
  assignmentExt: AssignmentExt & { isSuccessor: boolean };
  count: number;
};

export type CourseInfo = {
  name: string;
  avgRate: number;
  preRequisitions: string;
  trainers: any[];
  startDate: moment.Moment;
  endDate: moment.Moment;
  finished: number;
  certificateUrl: string;
  sections: any[];
  logo: string;
  comments: Comment[];
  isIssuedCertificate: boolean;
  learningProof: string;
  rateReviewCount: number;
  rating: any[];
  isOnline: boolean;
  description: string;
  educationPeriod: number;
  educationDuration: number;
  enrollmentId: string;
  selfEnrollment: boolean;
};
